import React, {
  ChangeEvent,
  Dispatch,
  ReactElement,
  useEffect,
  useRef,
  useState,
} from "react";
import closeIco from "../../assets/close-icon-color.png";
import {
  AtmosphericRiversIcon,
  BackIcon,
  CycloneIcon,
  DesertIcon,
  DownIcon,
  EarlyWarningIcon,
  JetSteamIcon,
  SandStormIcon,
  StormSurgeIcon,
  TornadoIcon,
  UpIcon,
  UserIcon,
} from "./IconSet";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useLayout } from "../../layout/LayoutContext";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import MonitorHeartIcon from "@mui/icons-material/MonitorHeart";
import { useTheme } from "../../theme/ThemeContext";
import {
  openWindowsMapRiver,
  RiverDetails,
  riverMap,
} from "../../riverSensors/RiverSensors";
import { map } from "../../mainLayer/MainLayer";
import RiverChartPopup from "./RiverChartPopup";
import ReactDOM from "react-dom";
import SensorsPopUp from "../../riverSensors/SensorsPopUp";
import Overlay from "ol/Overlay";
import SideMenuAirQualityPopup from "./SideMenuAirQualityPopup";
import {
  AirQualityDetails,
  airQualityMap,
  openWindowsAirQualityMap,
} from "../../mainLayer/airQuality/airQuality";
import AirQualityPopup from "../../mainLayer/airQuality/airQualityPopup";
import SideMenuEarlyWarningPopup from "./SideMenuEarlyWarningPopup";
import SideMenuReportedIncident from "./SideMenuReportedIncident";
import EarlyWarningPopup from "../../mainLayer/earlyWarning/EarlyWarningPopup";
import ReportIncidentPopUp from "../../mainLayer/hazardIncidentsLayers/ReportIncidentPopUp";
import { Coordinate } from "ol/coordinate";
import { useEWSContext } from "../../provider/EWSProvider";
import { useHzContext } from "../../provider/HzProvider";
import userIcon from "../../assets/user-ico.png";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import GridLayout, { Layout } from "react-grid-layout";
import "react-resizable/css/styles.css";
import SideMenuFloodSimulation from "./SideMenuFloodSimulation";
import { NotificationType } from "../../mainLayer/simulationPopup/NotificationPopup";
import {
  earlyWarning,
  EWSSidebarMap,
  openEwsWindowsMap,
} from "../../mainLayer/earlyWarning/ShowEarlyWarning";
import {
  hzIncidents,
  HzSidebarMap,
  // HzSidebarMap,
  incidentsSidebar,
  openWindowsHzMap,
} from "../../mainLayer/hazardIncidentsLayers/IncidentsMenuDropDown";
import SumDetailByType from "./summery/SumDetailByType";
import SumServerity from "./summery/SumServerity";
import SumFull from "./summery/SumFull";
import singleWindowIcon from "../../assets/single-window-ico.png";
import multiWindowIcon from "../../assets/multi-window-ico.png";
import { useAllWeatherContext } from "../../provider/AllWeatherProvider";
import Cyclones from "../../mainLayer/extremeWeather/Cyclones";
import AtmosphericRivers from "../../mainLayer/extremeWeather/AtmosphericRivers";
import Tornados from "../../mainLayer/extremeWeather/Tornados";
import Droughts from "../../mainLayer/extremeWeather/Droughts";
import JetStreams from "../../mainLayer/extremeWeather/JetStreams";
import StormSurges from "../../mainLayer/extremeWeather/StormSurges";
import DustStorms from "../../mainLayer/extremeWeather/DustStorms";
import { useRiverContext } from "../../provider/RiverProvider";
import { useAirQualityContext } from "../../provider/AirQualityProvider";
import { useRainfallContext } from "../../provider/RainfallProvider";
import RainfallPopup from "../../mainLayer/rainfall/RainfallPopup";
import {
  openWindowsRainfallMap,
  RainfallDetails,
  rainfallMap,
} from "../../mainLayer/rainfall/Rainfall";
import SideMenuRainfallPopup from "./SideMenuRainfallPopup";
import SideMenuTornadoSimPopup from "./SideMenuTornadoSimPopup";
import LayersWindow from "../../loadLayers/LayersWindow";
import Tides from "../../loadLayers/Tides";
/* New start */
type SetupDateType = {
  startDate: Date;
  endDate: Date;
};

type ChildrenItem = {
  subItemName: string;
  status: boolean;
  color?: string;
  img?: ReactElement<any, any>;
};

export type SideMenuItemType = {
  itemName: string;
  status: boolean;
  children: ChildrenItem[];
};

type SideMenuPropsType = {
  setMenuStatus: Dispatch<React.SetStateAction<boolean>>;
  menuStatus: boolean;
  popups: PopupsListType[];
  setPopups: Dispatch<React.SetStateAction<PopupsListType[]>>;
  getModularOpened: string;
  closeModular: () => void;
  getRiverSensorRender: boolean;
  getAirQualityRender: boolean;
  getSensorType: string;
  getRenderEWS: boolean;
  openModularArraysNotNull: () => void;
  getRenderHz: boolean;
  terminalState: Dispatch<React.SetStateAction<boolean>>;
  terminalCommands: Dispatch<React.SetStateAction<string[]>>;
  notifications: Dispatch<React.SetStateAction<NotificationType[]>>;
  detailsByTypeOpen: boolean;
  earlyWarningsFromChild: earlyWarning[];
  filterHzByType: hzIncidents[];
  filterEws: earlyWarning[];
  isEwsServerityOpen: boolean;
  isSummaryMoreDetailsOpen: boolean;
  earlyWarningsFull: earlyWarning[];
  hzDatafromSummery: hzIncidents[];
  ewSeverityWindow: Dispatch<React.SetStateAction<boolean>>;
  typeWindow: Dispatch<React.SetStateAction<boolean>>;
  moreDetailWindow: Dispatch<React.SetStateAction<boolean>>;
  handleClosePopup: () => void;
  runButtonOnClick: (simulationName: string) => void;
  onClose: () => void;
  onCloseByType: () => void;
  onCloseBySeverity: () => void;
  getSummeryType: string;
  closeAllSum: () => void;
  openSimulation: () => void;
  floodSimulationPopup: boolean;
  timeLineHour: string;
  timeLineDate: string;
  selectModel: string;
  openModular: () => void;
  openTornadoSimulation: () => void;
};

interface EwsSidebar {
  sensorId: string | null;
  coordinates: Coordinate | null;
  adm4_en: string | null;
  active_pcode: string | null;
  end_time: string | null;
  s_desc: string | null;
  severity_index: string | null;
  severity: string | null;
  adm4_pcode: string | null;
  adm3_pcode: string | null;
  adm3_en: string | null;
  adm2_pcode: string | null;
  adm2_en: string | null;
  active_alevel: string | null;
  en_desc: string | null;
  validityPeriod: string | null;
  issued_time: string | null;
  w_status: string | null;
  w_desc: string | null;
  w_name: string | null;
  w_type: string | null;
  adm1_en: string | null;
}

export type PopupsListType = {
  name: string;
  id: string;
};

export type SimulationType = {
  id: string;
};

export type InfoType = {
  id: string;
};

export let loginTime: string = "";
export const addOopenWidows: Array<string> = [];
let lastChangeLayoutEW: Layout[] = [];
let removeItemIndexEW: { index: number; object: EwsSidebar }[] = [];
let lastChangeLayoutHz: Layout[] = [];
let removeItemIndexHz: { index: number; object: incidentsSidebar }[] = [];
let lastChangeLayoutAir: Layout[] = [];
let removeItemIndexAir: { index: number; object: AirQualityDetails }[] = [];
let lastChangeLayoutRiver: Layout[] = [];
let removeItemIndexRiver: { index: number; object: RiverDetails }[] = [];
let lastChangeLayoutRain: Layout[] = [];
let removeItemIndexRain: { index: number; object: RiverDetails }[] = [];

let lastChangeLayoutCycloneSim: Layout[] = [];
let removeItemIndexCycloneSim: { index: number; object: PopupsListType }[] = [];

let lastChangeLayoutAtmosphericRiverSim: Layout[] = [];
let removeItemIndexAtmosphericRiverSim: {
  index: number;
  object: PopupsListType;
}[] = [];

let lastChangeLayoutTornadoSim: Layout[] = [];
let removeItemIndexTornadoSim: { index: number; object: PopupsListType }[] = [];

let lastChangeLayoutDroughtSim: Layout[] = [];
let removeItemIndexDroughtSim: { index: number; object: PopupsListType }[] = [];

let lastChangeLayoutJestStreamsSim: Layout[] = [];
let removeItemIndexJestStreamsSim: { index: number; object: PopupsListType }[] =
  [];

let lastChangeLayoutStormSurgeSim: Layout[] = [];
let removeItemIndexStormSurgeSim: { index: number; object: PopupsListType }[] =
  [];

let lastChangeLayoutDustSurgeSim: Layout[] = [];
let removeItemIndexDustSurgeSim: { index: number; object: PopupsListType }[] =
  [];

export type ItemTypes =
  | "ew"
  | "river"
  | "air"
  | "hz"
  | "heavy_rain"
  | "simulation"
  | "info"
  | "sumDetail"
  | "sumServerity"
  | "rain"
  | "cyclone_sim"
  | "atmospheric_river"
  | "tornado"
  | "droughts"
  | "JetStream"
  | "stormSurges"
  | "dustSurges";

const MenuItemList: SideMenuItemType[] = [
  {
    itemName: "theme",
    status: false,
    children: [
      {
        subItemName: "light",
        status: false,
        color: "rgb(141, 213, 254)",
      },
      {
        subItemName: "dark",
        status: true,
        color: "#000000",
      },
      {
        subItemName: "classic",
        status: false,
        color: "rgb(88, 105, 122)",
      },
      {
        subItemName: "dark blue",
        status: false,
        color: "rgb(6, 10, 75)",
      },
    ],
  },
  {
    itemName: "layout",
    status: false,
    children: [
      {
        subItemName: "modular",
        status: true,
        img: <ViewModuleIcon className={`icon`} />,
      },
      {
        subItemName: "hawk eye",
        status: false,
        img: <RemoveRedEyeIcon className={`layout-icon`} />,
      },
    ],
  },
  {
    itemName: "simulation",
    status: false,
    children: [
      {
        subItemName: "Flood Simulation",
        status: false,
        img: (
          <EarlyWarningIcon
            className={`layout-icon`}
            width="1rem"
            bgColor="none"
            lineColor="var(--text-color)"
          />
        ),
      },
    ],
  },
];

const RightSideMenu = (props: SideMenuPropsType) => {
  const { setAtmosphericRivers } = useAllWeatherContext();
  const { HzOpenSidebarMap, removeFromHzOpenSidebarMap } = useHzContext();
  const { EWSOpenSidebarMap, removeFromEWSOpenSidebarMap } = useEWSContext();
  const { RiverOpenSidebarMap, removeFromRiverOpenSidebarMap } =
    useRiverContext();
  const { AirQualityOpenSidebarMap, removeFromAirQualityOpenSidebarMap } =
    useAirQualityContext();
  const { RainfallOpenSidebarMap, removeFromRainfallOpenSidebarMap } =
    useRainfallContext();
  const { theme, setTheme } = useTheme();
  const { layout, setLayout } = useLayout();
  const [currentPage, setCurrentPage] = useState("sidebarMain");
  // Side menu width
  const [sideMenuWidth, setSideMenuWidth] = useState<number>(0);
  // Menu items
  const [menuItems, setMenuItems] = useState<SideMenuItemType[]>(MenuItemList);
  // Setup date
  const [setupDate, setSetupDate] = useState<SetupDateType | null>(null);
  // Selected gauges
  const [selectedGauges, setSelectedGauges] = useState<string[]>([]);
  const [riverSensorRender, setRiverSensorRender] = useState(false);
  const [isExtremeWeatherEventsOpen, setIsExtremeWeatherEventsOpen] =
    useState<boolean>(false);
  const [isLayersOpen, setIsLayersOpen] = useState<boolean>(false);
  const [renderModular, setRenderModular] = useState(false);
  const [forwardIcon, setForwardIcon] = useState(false);
  const [riverpopupclose, setRiverpopupclose] = useState(false);
  const [airQualitypopupclose, setAirQualitypopupclose] = useState(false);
  const [rainfallpopupclose, setRainfallpopupclose] = useState(false);
  const [ewspopupclose, setEwspopupclose] = useState(false);
  const [hzpopupclose, setHzpopupclose] = useState(false);
  const draggerElementRef = useRef<HTMLDivElement | null>(null);
  const sideMenuElementRef = useRef<HTMLDivElement | null>(null);
  const [riverMapEntries, setRiverMapEntries] = useState(
    Array.from(RiverOpenSidebarMap.values())
  );

  const [airQualityMapEntries, setAirQualityMapEntries] = useState(
    Array.from(AirQualityOpenSidebarMap.values())
  );
  const [EWSMapEntries, setEWSMapEntries] = useState(
    Array.from(EWSOpenSidebarMap.values())
  );
  const [HzMapEntries, setHzMapEntries] = useState(
    Array.from(HzOpenSidebarMap.values())
  );
  const [rainfallMapEntries, setRainfallMapEntries] = useState(
    Array.from(RainfallOpenSidebarMap.values())
  );
  const [airQualityTemp, setAirQualityTemp] = useState<AirQualityDetails[]>([]);
  const [ewsTemp, setEwsTemp] = useState<EwsSidebar[]>([]);
  const [rainfallTemp, setRainfallTemp] = useState<RainfallDetails[]>([]);

  const logout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("username");
    window.location.href = "/";
  };

  const [loginTime, setLoginTime] = useState("");

  useEffect(() => {
    const storedLoginTime = localStorage.getItem("loginTime");
    if (storedLoginTime) {
      setLoginTime(new Date(storedLoginTime).toLocaleString()); // Format the time
    }
  }, []);

  useEffect(() => {
    setAirQualityTemp(airQualityMapEntries);
    if (airQualityMapEntries.length === 0) {
      setTempPopupsAir([]);
    }
  }, [airQualityMapEntries]);

  // useEffect(() => {
  //   setAirQualityTemp(airQualityMapEntries);
  // }, [props.getSensorType]);

  useEffect(() => {
    setRainfallTemp(rainfallMapEntries);
    if (rainfallMapEntries.length === 0) {
      setTempPopupsRain([]);
    }
  }, [rainfallMapEntries]);

  useEffect(() => {
    setRainfallTemp(rainfallMapEntries);
    setAirQualityTemp(airQualityMapEntries);
  }, [props.getSensorType]);

  useEffect(() => {
    setEwsTemp(EWSMapEntries);
    if (EWSMapEntries.length === 0) {
      setTempPopupsEW([]);
    }
  }, [EWSMapEntries]);

  useEffect(() => {
    if (riverMapEntries.length === 0) {
      setTempPopupsRiver([]);
    }
  }, [riverMapEntries]);

  useEffect(() => {
    if (HzMapEntries.length === 0) {
      setTempPopupsHz([]);
    }
  }, [HzMapEntries]);

  const handleActivePcode = (activePcode: string | null) => {
    if (activePcode) {
      setEwsTemp((prevEwsTemp) =>
        prevEwsTemp.filter((entry) => entry.active_pcode !== activePcode)
      );
    }
  };

  useEffect(() => {}, [ewsTemp]);

  // handle drag
  const prevLocationRef = useRef<number>(0);
  const handleDrag = (event: MouseEvent) => {
    if (sideMenuElementRef.current) {
      const tempContainerWidth: number = Number(
        window.getComputedStyle(sideMenuElementRef.current).width.slice(0, -2)
      );
      sideMenuElementRef.current.style.width = `${
        tempContainerWidth + -(event.clientX - prevLocationRef.current)
      }px`;
      setSideMenuWidth(
        tempContainerWidth + -(event.clientX - prevLocationRef.current)
      );
    }
    prevLocationRef.current = event.clientX;
  };

  const handleDragTouch = (event: TouchEvent) => {
    if (sideMenuElementRef.current) {
      const touchX = event.touches[0].clientX; // Get touch position
      const tempContainerWidth: number = Number(
        window.getComputedStyle(sideMenuElementRef.current).width.slice(0, -2)
      );
      sideMenuElementRef.current.style.width = `${
        tempContainerWidth + -(touchX - prevLocationRef.current)
      }px`;
      setSideMenuWidth(
        tempContainerWidth + -(touchX - prevLocationRef.current)
      );
      prevLocationRef.current = touchX; // Update prev location for next move
    }
  };

  // useEffect(() => {
  //   if (sideMenuElementRef.current) {
  //     setSideMenuWidth(
  //       Number(
  //         window.getComputedStyle(sideMenuElementRef.current).width.slice(0, -2)
  //       )
  //     );
  //   }

  //   draggerElementRef.current?.addEventListener("mouseenter", () => {
  //     draggerElementRef.current?.addEventListener(
  //       "mousedown",
  //       (event: MouseEvent) => {
  //         prevLocationRef.current = event.clientX;
  //         document.addEventListener("mousemove", handleDrag);
  //       }
  //     );
  //     document.addEventListener("mouseup", () => {
  //       document.removeEventListener("mousemove", handleDrag);
  //     });
  //   });
  // }, []);

  useEffect(() => {
    if (sideMenuElementRef.current) {
      setSideMenuWidth(
        Number(
          window.getComputedStyle(sideMenuElementRef.current).width.slice(0, -2)
        )
      );
    }

    const handleMouseDown = (event: MouseEvent) => {
      prevLocationRef.current = event.clientX;
      document.addEventListener("mousemove", handleDrag);
    };

    const handleMouseUp = () => {
      document.removeEventListener("mousemove", handleDrag);
    };

    const handleTouchStart = (event: TouchEvent) => {
      prevLocationRef.current = event.touches[0].clientX;
      document.addEventListener("touchmove", handleDragTouch);
    };

    const handleTouchEnd = () => {
      document.removeEventListener("touchmove", handleDragTouch);
    };

    draggerElementRef.current?.addEventListener("mouseenter", () => {
      draggerElementRef.current?.addEventListener("mousedown", handleMouseDown);
      document.addEventListener("mouseup", handleMouseUp);

      draggerElementRef.current?.addEventListener(
        "touchstart",
        handleTouchStart
      );
      document.addEventListener("touchend", handleTouchEnd);
    });

    return () => {
      draggerElementRef.current?.removeEventListener(
        "mousedown",
        handleMouseDown
      );
      document.removeEventListener("mouseup", handleMouseUp);

      draggerElementRef.current?.removeEventListener(
        "touchstart",
        handleTouchStart
      );
      document.removeEventListener("touchend", handleTouchEnd);
    };
  }, []);

  // Handle parent item container
  const handleParentItemClick = (name: string) => {
    setMenuItems((prevState) =>
      prevState.map((item) =>
        item.itemName === name ? { ...item, status: !item.status } : item
      )
    );
  };

  const [isSideMenuSimulationStatus, setIsSideMenuSimulationStatus] =
    useState<boolean>(false);

  const [
    isSideMenuSimulationCycloneSimStatus,
    setIsSideMenuSimulationCycloneSimStatus,
  ] = useState<boolean>(false);

  const [
    isSideMenuSimulationAtmosphericRiverSimStatus,
    setIsSideMenuSimulationAtmosphericRiverSimStatus,
  ] = useState<boolean>(false);

  const [
    isSideMenuSimulationTornadoSimStatus,
    setIsSideMenuSimulationTornadoSimStatus,
  ] = useState<boolean>(false);

  const [
    isSideMenuSimulationDroughtSimStatus,
    setIsSideMenuSimulationDroughtSimStatus,
  ] = useState<boolean>(false);

  const [
    isSideMenuSimulationJestStreamsSimStatus,
    setIsSideMenuSimulationJestStreamsSimStatus,
  ] = useState<boolean>(false);

  const [
    isSideMenuSimulationStormSurgeSimStatus,
    setIsSideMenuSimulationStormSurgeSimStatus,
  ] = useState<boolean>(false);

  const [
    isSideMenuSimulationDustSurgeSimStatus,
    setIsSideMenuSimulationDustSurgeSimStatus,
  ] = useState<boolean>(false);

  useEffect(() => {
    setMenuItems((prevState) => {
      const newState = prevState.map((parent) => {
        if (parent.itemName === "simulation") {
          return {
            ...parent,
            children: parent.children.map((child) =>
              child.subItemName === "Flood Simulation"
                ? { ...child, status: isSideMenuSimulationStatus }
                : { ...child, status: false }
            ),
          };
        }
        return parent;
      });
      return newState;
    });
  }, [isSideMenuSimulationStatus]);

  useEffect(() => {
    if (!props.floodSimulationPopup) {
      setIsSideMenuSimulationStatus(false);
    }
  }, [props.floodSimulationPopup]);

  useEffect(() => {}, [forwardIcon]);

  // Handle theme button click
  const handleThemeButtonClick = (
    event: any,
    parentName: string,
    name: string
  ) => {
    if (parentName === "theme") {
      // handle item clicked theme change
      if (name === "light") {
        setTheme("light");
        setRenderModular((prev) => !prev);
      } else if (name === "dark") {
        setTheme("dark");
      } else if (name === "classic") {
        setTheme("classic");
      } else if (name === "dark blue") {
        setTheme("darkblue");
      }
      setMenuItems((prevState) => {
        const newState = prevState.map((parent) => {
          if (parent.itemName === parentName) {
            return {
              ...parent,
              children: parent.children.map((child) =>
                child.subItemName === name
                  ? { ...child, status: true }
                  : { ...child, status: false }
              ),
            };
          }
          return parent;
        });
        return newState;
      });
    } else if (parentName === "layout") {
      // handle item clicked layer section change
      if (name === "modular") {
        setLayout("modular");
        setForwardIcon(false);
        map.getOverlays().clear();
        if (
          riverMapEntries.length != 0 ||
          airQualityMapEntries.length != 0 ||
          EWSMapEntries.length != 0 ||
          HzMapEntries.length != 0 ||
          rainfallMapEntries.length != 0
        ) {
          props.openModularArraysNotNull();
        }
      } else if (name === "hawk eye") {
        setLayout("hawk eye");
        setForwardIcon(true);
        riverMapEntries.map((river) => {
          const popupElement = document.createElement("riverSensor");

          ReactDOM.render(
            <SensorsPopUp
              sensorId={river.sensorId!}
              name={river.name!}
              cautionLevel={river.cautionLevel!}
              warningLevel={river.warningLevel!}
              criticalLevel={river.criticalLevel!}
              onClose={handleClose}
            />,
            popupElement
          );
          const overlay = new Overlay({
            element: popupElement,
            autoPan: {
              animation: {
                duration: 250,
              },
            },
          });
          overlay.setPosition(river.coordinates!);
          map.addOverlay(overlay);
        });

        airQualityMapEntries.map((airQuality) => {
          const popupElement = document.createElement("airQuality");

          ReactDOM.render(
            <AirQualityPopup
              sensorId={airQuality.sensorId!}
              name={airQuality.name!}
              pm10={airQuality.pm10!}
              pm25={airQuality.pm25!}
              pm100={airQuality.pm100!}
              co2={airQuality.co2!}
              temperature={airQuality.temperature!}
              aqi={airQuality.aqi!}
              timestamp={airQuality.timestamp!}
              onClose={handleCloseAirQuality}
            />,
            popupElement
          );
          const overlay = new Overlay({
            element: popupElement,
            autoPan: {
              animation: {
                duration: 250,
              },
            },
          });

          overlay.setPosition(airQuality.coordinates!);
          map.addOverlay(overlay);
        });

        EWSMapEntries.map((ews) => {
          const popupElement = document.createElement("ews");

          ReactDOM.render(
            <EarlyWarningPopup
              warningId={ews.sensorId!}
              coordinates={ews.coordinates}
              adm4_en={ews.adm4_en}
              active_pcode={ews.active_pcode}
              end_time={ews.end_time}
              s_desc={ews.s_desc}
              severity_index={ews.severity_index}
              severity={ews.severity}
              adm4_pcode={ews.adm4_pcode}
              adm3_pcode={ews.adm3_pcode}
              adm3_en={ews.adm3_en}
              adm2_pcode={ews.adm2_pcode}
              adm2_en={ews.adm2_en}
              active_alevel={ews.active_alevel}
              en_desc={ews.en_desc}
              validityPeriod={ews.validityPeriod}
              issued_time={ews.issued_time}
              w_status={ews.w_status}
              w_desc={ews.w_desc}
              w_name={ews.w_name}
              w_type={ews.w_type}
              onClose={handleCloseEWS}
              adm1_en={ews.adm1_en}
            />,
            popupElement
          );
          const overlay = new Overlay({
            element: popupElement,
            autoPan: {
              animation: {
                duration: 250,
              },
            },
          });
          overlay.setPosition(ews.coordinates!);
          map.addOverlay(overlay);
        });

        HzMapEntries.map((hz) => {
          const popupElement = document.createElement("hz");

          ReactDOM.render(
            <ReportIncidentPopUp
              incidentId={hz.sensorId!}
              adm4_en={hz.adm4_en}
              bwater_level={hz.bwater_level}
              end_time={hz.end_time}
              hwater_level={hz.hwater_level}
              img_url={hz.img_url}
              imp_communication={hz.imp_communication}
              imp_electricity={hz.imp_electricity}
              imp_house={hz.imp_house}
              imp_human={hz.imp_human}
              imp_response={hz.imp_response}
              imp_roadblock={hz.imp_roadblock}
              imp_roaddamage={hz.imp_roaddamage}
              imp_water={hz.imp_water}
              impdes_communication={hz.impdes_communication}
              impdes_electricity={hz.impdes_electricity}
              impdes_house={hz.impdes_house}
              impdes_human={hz.impdes_human}
              impdes_roadblock={hz.impdes_roadblock}
              impdes_roaddamage={hz.impdes_roaddamage}
              impdes_water={hz.impdes_water}
              issued_time={hz.issued_time}
              occurance_date={hz.occurance_date}
              observed_date={hz.observed_date}
              tp_number={hz.tp_number}
              w_desc={hz.w_desc}
              w_name={hz.w_name}
              w_type={hz.w_type}
              onClose={handleCloseHz}
            />,
            popupElement
          );
          const overlay = new Overlay({
            element: popupElement,
            autoPan: {
              animation: {
                duration: 250,
              },
            },
          });
          overlay.setPosition(hz.coordinates!);
          map.addOverlay(overlay);
        });

        rainfallMapEntries.map((rain) => {
          const popupElement = document.createElement("rain");

          ReactDOM.render(
            <RainfallPopup
              sensorId={rain.sensorId!}
              name={rain.name!}
              // cautionLevel={rain.cautionLevel!}
              // warningLevel={rain.warningLevel!}
              // criticalLevel={rain.criticalLevel!}

              onClose={handleCloseRainfall}
            />,
            popupElement
          );
          const overlay = new Overlay({
            element: popupElement,
            autoPan: {
              animation: {
                duration: 250,
              },
            },
          });

          overlay.setPosition(rain.coordinates!);
          map.addOverlay(overlay);
        });
      }

      setMenuItems((prevState) => {
        const newState = prevState.map((parent) => {
          if (parent.itemName === parentName) {
            return {
              ...parent,
              children: parent.children.map((child) =>
                child.subItemName === name
                  ? { ...child, status: true }
                  : { ...child, status: false }
              ),
            };
          }
          return parent;
        });
        return newState;
      });
    } else if (parentName === "simulation") {
      // handle item clicked layer section change
      if (name === "Flood Simulation") {
        if (layout === "modular") {
          props.openModularArraysNotNull();
          setIsSideMenuSimulationStatus((prevStatus) => !prevStatus);
        } else if (layout === "hawk eye") {
          setIsSideMenuSimulationStatus((prevStatus) => !prevStatus);
        }
        props.openSimulation();
      }
      //  else if (name === "heavy rainfall") {
      // }

      setMenuItems((prevState) => {
        const newState = prevState.map((parent) => {
          if (parent.itemName === parentName) {
            return {
              ...parent,
              children: parent.children.map((child) =>
                child.subItemName === name
                  ? { ...child, status: !child.status }
                  : { ...child }
              ),
            };
          }
          return parent;
        });
        return newState;
      });
    } else if (parentName === "Extreme Weather Events") {
      if (name === "Tornado") {
        if (layout === "modular") {
          props.openModularArraysNotNull();
          setIsSideMenuSimulationTornadoSimStatus((prevStatus) => !prevStatus);
        } else if (layout === "hawk eye") {
          setIsSideMenuSimulationTornadoSimStatus((prevStatus) => !prevStatus);
        }
        props.openTornadoSimulation();
      }
    }
  };

  const handleClose = (incidentId: string) => {
    openWindowsMapRiver.set(incidentId, "close");
    if (RiverOpenSidebarMap.has(incidentId)) {
      RiverOpenSidebarMap.delete(incidentId);
    }
    removeFromRiverOpenSidebarMap(incidentId);
    if (riverMap.has(incidentId)) {
      riverMap.delete(incidentId);
    }
  };

  const handleCloseAirQuality = (incidentId: string) => {
    openWindowsAirQualityMap.set(incidentId, "close");
    if (airQualityMap.has(incidentId)) {
      airQualityMap.delete(incidentId);
    }
    removeFromAirQualityOpenSidebarMap(incidentId);
    if (AirQualityOpenSidebarMap.has(incidentId)) {
      AirQualityOpenSidebarMap.delete(incidentId);
    }
  };

  const handleCloseRainfall = (sensorId: string) => {
    openWindowsRainfallMap.set(sensorId, "close");
    if (rainfallMap.has(sensorId)) {
      rainfallMap.delete(sensorId);
    }
    removeFromRainfallOpenSidebarMap(sensorId);
    if (RainfallOpenSidebarMap.has(sensorId)) {
      RainfallOpenSidebarMap.delete(sensorId);
    }
  };

  const handleCloseEWS = (incidentId: string) => {
    openEwsWindowsMap.set(incidentId, "close");
    removeFromEWSOpenSidebarMap(incidentId);
    if (EWSSidebarMap.has(incidentId)) {
      EWSSidebarMap.delete(incidentId);
    }
  };

  const handleCloseHz = (incidentId: string) => {
    openWindowsHzMap.set(incidentId, "close");
    removeFromHzOpenSidebarMap(incidentId);
    if (HzSidebarMap.has(incidentId)) {
      HzSidebarMap.delete(incidentId);
    }
  };

  const handleBackButtonClick = () => {
    props.closeModular();
  };

  const handleForwardButtonClick = () => {
    props.openModular();
  };

  useEffect(() => {
    setRiverMapEntries(Array.from(RiverOpenSidebarMap.values()));
    //setTempPopupsRiver(Array.from(riverMap.values()));
  }, [RiverOpenSidebarMap.size, renderModular]);

  const toggleRiverSensorRender = () => {
    setRiverpopupclose((prevState) => !prevState);
  };

  useEffect(() => {
    setRiverMapEntries(Array.from(RiverOpenSidebarMap.values()));
    // setTempPopupsRiver(Array.from(riverMap.values()));
  }, [riverpopupclose]);

  useEffect(() => {
    setAirQualityMapEntries(Array.from(AirQualityOpenSidebarMap.values()));
    // if(AirQualityOpenSidebarMap.size===0){
    //   setTempPopupsAir([])
    // }

    //setTempPopupsAir(Array.from(airQualityMap.values()));
  }, [AirQualityOpenSidebarMap.size, renderModular]);

  const toggleAirQualityRender = () => {
    setAirQualitypopupclose((prevState) => !prevState);
  };

  useEffect(() => {
    setAirQualityMapEntries(Array.from(AirQualityOpenSidebarMap.values()));
    // setTempPopupsAir(Array.from(airQualityMap.values()));
  }, [airQualitypopupclose]);

  useEffect(() => {
    setRainfallMapEntries(Array.from(RainfallOpenSidebarMap.values()));
  }, [RainfallOpenSidebarMap.size, renderModular]);

  const toggleRainfallRender = () => {
    setRainfallpopupclose((prevState) => !prevState);
  };

  useEffect(() => {
    setRainfallMapEntries(Array.from(RainfallOpenSidebarMap.values()));
    // setTempPopupsAir(Array.from(airQualityMap.values()));
  }, [rainfallpopupclose]);

  useEffect(() => {
    setEWSMapEntries(Array.from(EWSOpenSidebarMap.values()));
    // setTempPopupsEW(Array.from(EWSOpenSidebarMap.values()));
  }, [EWSOpenSidebarMap.size, renderModular]);

  useEffect(() => {
    setHzMapEntries(Array.from(HzOpenSidebarMap.values()));

    // setTempPopupsHz(Array.from(HzOpenSidebarMap.values()));
  }, [HzOpenSidebarMap.size, renderModular]);

  useEffect(() => {
    setTempPopupsEW(Array.from(EWSOpenSidebarMap.values()));
    setTempPopupsHz(Array.from(HzOpenSidebarMap.values()));
    setTempPopupsRiver(Array.from(RiverOpenSidebarMap.values()));
    setTempPopupsAir(Array.from(AirQualityOpenSidebarMap.values()));
    setTempPopupsRain(Array.from(RainfallOpenSidebarMap.values()));
  }, [layout]);

  // useEffect(() => {
  //   if (props.getSensorType !== "riverSensor") {
  //     riverMapEntries.map((river) =>
  //       openWindowsMapRiver.set(river.sensorId!, "close")
  //     );
  //   }
  // }, [riverMapEntries]);

  const toggleEWSRender = () => {
    setEwspopupclose((prevState) => !prevState);
  };

  useEffect(() => {
    setEWSMapEntries(Array.from(EWSOpenSidebarMap.values()));
    // setTempPopupsEW(Array.from(EWSOpenSidebarMap.values()));
  }, [ewspopupclose]);

  const toggleHzRender = () => {
    setHzpopupclose((prevState) => !prevState);
  };

  useEffect(() => {
    setHzMapEntries(Array.from(HzOpenSidebarMap.values()));
    // setTempPopupsHz(Array.from(HzOpenSidebarMap.values()));
  }, [hzpopupclose]);

  const [multiWindow, setMultiWindow] = useState(true);
  const [singleWindow, setSingleWindow] = useState(false);

  // Handle multi window button click
  const handleMultiWindowClick = () => {
    setMultiWindow(false);
    setSingleWindow(true);
    if (tempPopupsAir.length > 0) {
      tempPopupsAir.forEach((popup, index) => {
        const isLastItem = index === tempPopupsAir.length - 1;
        removeOverlay(popup.sensorId!);
        if (isLastItem) {
          addOverlayClickItemLast(popup.sensorId!, popup.coordinates!);
        }
      });
    } else if (tempPopupsRiver.length > 0) {
      tempPopupsRiver.forEach((popup, index) => {
        const isLastItem = index === tempPopupsRiver.length - 1;
        removeOverlay(popup.sensorId!);
        if (isLastItem) {
          addOverlayClickItemLast(popup.sensorId!, popup.coordinates!);
        }
      });
    } else if (tempPopupsEW.length > 0) {
      tempPopupsEW.forEach((popup, index) => {
        const isLastItem = index === tempPopupsEW.length - 1;
        removeOverlay(popup.active_pcode!);
        if (isLastItem) {
          addOverlayClickItemLast(popup.active_pcode!, popup.coordinates!);
        }
      });
    } else if (tempPopupsHz.length > 0) {
      tempPopupsHz.forEach((popup, index) => {
        const isLastItem = index === tempPopupsHz.length - 1;
        removeOverlay(popup.sensorId!);
        if (isLastItem) {
          addOverlayClickItemLast(popup.sensorId!, popup.coordinates!);
        }
      });
    } else if (tempPopupsRain.length > 0) {
      tempPopupsRain.forEach((popup, index) => {
        const isLastItem = index === tempPopupsRain.length - 1;
        removeOverlay(popup.sensorId!);
        if (isLastItem) {
          addOverlayClickItemLast(popup.sensorId!, popup.coordinates!);
        }
      });
    }
  };
  // Handle single window button click
  const handleSingleWindowClick = () => {
    setSingleWindow(false);
    setMultiWindow(true);
    if (tempPopupsAir.length > 0) {
      tempPopupsAir.forEach((popup, index) => {
        const isLastItem = index === tempPopupsAir.length - 1;
        removeOverlay(popup.sensorId!);
        if (isLastItem) {
          addOverlayClickItemLast(popup.sensorId!, popup.coordinates!);
        } else {
          addOverlayClickItem(popup.sensorId!, popup.coordinates!);
        }
      });
    } else if (tempPopupsRiver.length > 0) {
      tempPopupsRiver.forEach((popup, index) => {
        const isLastItem = index === tempPopupsRiver.length - 1;
        removeOverlay(popup.sensorId!);
        if (isLastItem) {
          addOverlayClickItemLast(popup.sensorId!, popup.coordinates!);
        } else {
          addOverlayClickItem(popup.sensorId!, popup.coordinates!);
        }
      });
    } else if (tempPopupsEW.length > 0) {
      tempPopupsEW.forEach((popup, index) => {
        const isLastItem = index === tempPopupsEW.length - 1;
        removeOverlay(popup.active_pcode!);
        if (isLastItem) {
          addOverlayClickItemLast(popup.active_pcode!, popup.coordinates!);
        } else {
          addOverlayClickItem(popup.active_pcode!, popup.coordinates!);
        }
      });
    } else if (tempPopupsHz.length > 0) {
      tempPopupsHz.forEach((popup, index) => {
        const isLastItem = index === tempPopupsHz.length - 1;
        removeOverlay(popup.sensorId!);
        if (isLastItem) {
          addOverlayClickItemLast(popup.sensorId!, popup.coordinates!);
        } else {
          addOverlayClickItem(popup.sensorId!, popup.coordinates!);
        }
      });
    }
    if (tempPopupsRain.length > 0) {
      tempPopupsRain.forEach((popup, index) => {
        const isLastItem = index === tempPopupsRain.length - 1;
        removeOverlay(popup.sensorId!);
        if (isLastItem) {
          addOverlayClickItemLast(popup.sensorId!, popup.coordinates!);
        } else {
          addOverlayClickItem(popup.sensorId!, popup.coordinates!);
        }
      });
    }
  };

  const removeOverlay = (key: string) => {
    const overlays = map.getOverlays().getArray();
    const overlaysToRemove = overlays.filter(
      (overlay) => overlay.getId() === key
    );
    overlaysToRemove.forEach((overlay) => {
      map.removeOverlay(overlay);
    });
  };

  const addOverlayClickItem = (id: string, coordinates: Coordinate) => {
    const markerElement = document.createElement("div");
    markerElement.className = "location-dot animate";

    const ringElement = document.createElement("div");
    ringElement.className = "location-dot-ring";

    markerElement.appendChild(ringElement);
    const overlay = new Overlay({
      id: id,
      position: coordinates,
      positioning: "center-center",
      element: markerElement,
      stopEvent: false,
    });
    map.addOverlay(overlay);
  };

  const addOverlayClickItemLast = (id: string, coordinates: Coordinate) => {
    const markerElement = document.createElement("div");
    markerElement.className = "locationlast-dot animate";

    const ringElement = document.createElement("div");
    ringElement.className = "locationlast-dot-ring";

    markerElement.appendChild(ringElement);
    const overlay = new Overlay({
      id: id,
      position: coordinates,
      positioning: "center-center",
      element: markerElement,
      stopEvent: false,
    });
    map.addOverlay(overlay);
  };

  useEffect(() => {}, [multiWindow, singleWindow]);

  const gridLayout: Layout[] = airQualityMapEntries
    .filter((item) => item.sensorId !== null)
    .map((item, index) => ({
      i: item.sensorId as string,
      x: 0,
      y: index,
      w: 1,
      h: 1,
    }));

  const gridLayoutRain: Layout[] = rainfallMapEntries
    .filter((item) => item.sensorId !== null)
    .map((item, index) => ({
      i: item.sensorId as string,
      x: 0,
      y: index,
      w: 1,
      h: 1,
    }));

  const gridLayoutRiver: Layout[] = riverMapEntries
    .filter((item) => item.sensorId !== null)
    .map((item, index) => ({
      i: item.sensorId as string,
      x: 0,
      y: index,
      w: 1,
      h: 1,
    }));

  const gridLayoutEWS: Layout[] = EWSMapEntries.filter(
    (item) => item.sensorId !== null
  ).map((item, index) => ({
    i: item.active_pcode as string,
    x: 0,
    y: index,
    w: 1,
    h: 1,
  }));

  const gridLayoutHz: Layout[] = HzMapEntries.filter(
    (item) => item.sensorId !== null
  ).map((item, index) => ({
    i: item.sensorId as string,
    x: 0,
    y: index,
    w: 1,
    h: 1,
  }));

  const [popupSimulation, setPopupSimulation] = useState<SimulationType[]>([
    { id: "1" },
  ]);
  const [popupInfo, setPopupInfo] = useState<SimulationType[]>([{ id: "1" }]);
  const [sumDetails, setSumDetails] = useState<SimulationType[]>([{ id: "1" }]);
  const [sumServerity, setSumServerity] = useState<SimulationType[]>([
    { id: "1" },
  ]);

  const gridLayoutSimulation: Layout[] = popupSimulation.map((item, index) => ({
    i: item.id,
    x: 0,
    y: index,
    w: 1,
    h: 1,
  }));

  const gridLayoutInfo: Layout[] = popupInfo.map((item, index) => ({
    i: item.id,
    x: 0,
    y: index,
    w: 1,
    h: 1,
  }));

  const gridLayoutSumDetails: Layout[] = sumDetails.map((item, index) => ({
    i: item.id,
    x: 0,
    y: index,
    w: 1,
    h: 1,
  }));

  const gridLayoutSumServerity: Layout[] = sumServerity.map((item, index) => ({
    i: item.id,
    x: 0,
    y: index,
    w: 1,
    h: 1,
  }));

  const [cycloneSim, setCycloneSim] = useState<SimulationType[]>([{ id: "1" }]);
  const gridLayoutCycloneSim: Layout[] = cycloneSim.map((item, index) => ({
    i: item.id,
    x: 0,
    y: index,
    w: 1,
    h: 1,
  }));

  const [atmosphericRiverSim, setAtmosphericRiverSim] = useState<
    SimulationType[]
  >([{ id: "1" }]);
  const gridLayoutAtmosphericRiverSim: Layout[] = atmosphericRiverSim.map(
    (item, index) => ({
      i: item.id,
      x: 0,
      y: index,
      w: 1,
      h: 1,
    })
  );

  const [tornadoSim, setTornadoSim] = useState<SimulationType[]>([{ id: "1" }]);
  const gridLayoutTornadoSim: Layout[] = tornadoSim.map((item, index) => ({
    i: item.id,
    x: 0,
    y: index,
    w: 1,
    h: 1,
  }));

  const [droughtSim, setDroughtSim] = useState<SimulationType[]>([{ id: "1" }]);
  const gridLayoutDroughtSim: Layout[] = droughtSim.map((item, index) => ({
    i: item.id,
    x: 0,
    y: index,
    w: 1,
    h: 1,
  }));

  const [jestStreamsSim, setJestStreamsSim] = useState<SimulationType[]>([
    { id: "1" },
  ]);
  const gridLayoutJestStreamsSim: Layout[] = jestStreamsSim.map(
    (item, index) => ({
      i: item.id,
      x: 0,
      y: index,
      w: 1,
      h: 1,
    })
  );

  const [stormSurgeSim, setStormSurgeSim] = useState<SimulationType[]>([
    { id: "1" },
  ]);
  const gridLayoutStormSurgeSim: Layout[] = stormSurgeSim.map(
    (item, index) => ({
      i: item.id,
      x: 0,
      y: index,
      w: 1,
      h: 1,
    })
  );

  const [dustSurgeSim, setDustSurgeSim] = useState<SimulationType[]>([
    { id: "1" },
  ]);
  const gridLayoutDustSurgeSim: Layout[] = dustSurgeSim.map((item, index) => ({
    i: item.id,
    x: 0,
    y: index,
    w: 1,
    h: 1,
  }));

  const [tempLayoutEW, setTempLayoutEW] = useState<Layout[]>(gridLayoutEWS);
  const [tempPopupsEW, setTempPopupsEW] = useState<EwsSidebar[]>([]);
  const [keyEW, setKeyEW] = useState<number>(0);

  const [tempLayoutRiver, setTempLayoutRiver] =
    useState<Layout[]>(gridLayoutRiver);
  const [tempPopupsRiver, setTempPopupsRiver] = useState<RiverDetails[]>([]);
  const [keyRiver, setKeyRiver] = useState<number>(0);

  const [tempLayoutAir, setTempLayoutAir] = useState<Layout[]>(gridLayout);
  const [tempPopupsAir, setTempPopupsAir] = useState<AirQualityDetails[]>([]);
  const [keyAir, setKeyAir] = useState<number>(0);

  const [tempLayoutRain, setTempLayoutRain] =
    useState<Layout[]>(gridLayoutRain);
  const [tempPopupsRain, setTempPopupsRain] = useState<RainfallDetails[]>([]);
  const [keyRain, setKeyRain] = useState<number>(0);

  const [tempLayoutHz, setTempLayoutHz] = useState<Layout[]>(gridLayoutHz);
  const [tempPopupsHz, setTempPopupsHz] = useState<incidentsSidebar[]>([]);
  const [keyHz, setKeyHz] = useState<number>(0);

  const [tempLayoutHR, setTempLayoutHR] = useState<Layout[]>(gridLayout);
  const [tempPopupsHR, setTempPopupsHR] = useState<PopupsListType[]>(
    props.popups
  );

  const [tempLayoutSimulation, setTempLayoutSimulation] =
    useState<Layout[]>(gridLayoutSimulation);
  const [tempPopupSimulation, setTempPopupSimulation] =
    useState<SimulationType[]>(popupSimulation);
  const [keySim, setKeySim] = useState<number>(0);

  const [tempLayoutInfo, setTempLayoutInfo] =
    useState<Layout[]>(gridLayoutInfo);
  const [tempPopupInfo, setTempPopupInfo] = useState<InfoType[]>(popupInfo);
  const [keyInfo, setKeyInfo] = useState<number>(0);

  const [sumDetail, setSumDetail] = useState<Layout[]>(gridLayoutSumDetails);
  const [tempSumDetails, setTempSumDetails] = useState<InfoType[]>(sumDetails);
  const [keyDetail, setKeyDetail] = useState<number>(0);
  const [SumDetailAdd, setSumDetailAdd] = useState<boolean>(false);

  const [sumSeverity, setSumSeverity] = useState<Layout[]>(
    gridLayoutSumServerity
  );
  const [tempSumSeverity, setTempSumSeverity] =
    useState<InfoType[]>(sumServerity);
  const [keySeverity, setKeySeverity] = useState<number>(0);
  const [SumSeverityAdd, setSumSeverityAdd] = useState<boolean>(false);

  useEffect(() => {
    if (Array.from(EWSOpenSidebarMap.values()).length > tempPopupsEW.length) {
      const extraObject = Array.from(EWSOpenSidebarMap.values()).filter(
        (obj) =>
          !tempPopupsEW.some((item) => item.active_pcode === obj.active_pcode)
      );
      tempPopupsEW.unshift(extraObject[0]);
    } else if (
      Array.from(EWSOpenSidebarMap.values()).length < tempPopupsEW.length
    ) {
      const tempRemoveItem: EwsSidebar[] = tempPopupsEW.filter(
        (item) =>
          !Array.from(EWSOpenSidebarMap.values()).some(
            (changeList) => changeList.active_pcode === item.active_pcode
          )
      );
      setTempPopupsEW((prevState) =>
        prevState.filter(
          (item) => item.active_pcode !== tempRemoveItem[0].active_pcode
        )
      );
    }
  }, [EWSMapEntries.length]);

  useEffect(() => {
    if (Array.from(HzOpenSidebarMap.values()).length > tempPopupsHz.length) {
      const extraObject = Array.from(HzOpenSidebarMap.values()).filter(
        (obj) => !tempPopupsHz.some((item) => item.sensorId === obj.sensorId)
      );
      tempPopupsHz.unshift(extraObject[0]);
    } else if (
      Array.from(HzOpenSidebarMap.values()).length < tempPopupsHz.length
    ) {
      const tempRemoveItem: incidentsSidebar[] = tempPopupsHz.filter(
        (item) =>
          !Array.from(HzOpenSidebarMap.values()).some(
            (changeList) => changeList.sensorId === item.sensorId
          )
      );
      setTempPopupsHz((prevState) =>
        prevState.filter((item) => item.sensorId !== tempRemoveItem[0].sensorId)
      );
    }
  }, [HzMapEntries.length]);

  useEffect(() => {
    if (
      Array.from(AirQualityOpenSidebarMap.values()).length >
      tempPopupsAir.length
    ) {
      const extraObject = Array.from(AirQualityOpenSidebarMap.values()).filter(
        (obj) => !tempPopupsAir.some((item) => item.sensorId === obj.sensorId)
      );
      tempPopupsAir.unshift(extraObject[0]);
    } else if (
      Array.from(AirQualityOpenSidebarMap.values()).length <
      tempPopupsAir.length
    ) {
      const tempRemoveItem: AirQualityDetails[] = tempPopupsAir.filter(
        (item) =>
          !Array.from(AirQualityOpenSidebarMap.values()).some(
            (changeList) => changeList.sensorId === item.sensorId
          )
      );
      setTempPopupsAir((prevState) =>
        prevState.filter((item) => item.sensorId !== tempRemoveItem[0].sensorId)
      );
    }
  }, [airQualityMapEntries.length]);

  useEffect(() => {
    if (
      Array.from(RainfallOpenSidebarMap.values()).length > tempPopupsRain.length
    ) {
      const extraObject = Array.from(RainfallOpenSidebarMap.values()).filter(
        (obj) => !tempPopupsRain.some((item) => item.sensorId === obj.sensorId)
      );
      tempPopupsRain.unshift(extraObject[0]);
    } else if (
      Array.from(RainfallOpenSidebarMap.values()).length < tempPopupsRain.length
    ) {
      const tempRemoveItem: RainfallDetails[] = tempPopupsRain.filter(
        (item) =>
          !Array.from(RainfallOpenSidebarMap.values()).some(
            (changeList) => changeList.sensorId === item.sensorId
          )
      );
      setTempPopupsRain((prevState) =>
        prevState.filter((item) => item.sensorId !== tempRemoveItem[0].sensorId)
      );
    }
  }, [rainfallMapEntries.length]);

  useEffect(() => {
    if (
      Array.from(RiverOpenSidebarMap.values()).length > tempPopupsRiver.length
    ) {
      const extraObject = Array.from(RiverOpenSidebarMap.values()).filter(
        (obj) => !tempPopupsRiver.some((item) => item.sensorId === obj.sensorId)
      );
      tempPopupsRiver.unshift(extraObject[0]);
    } else if (
      Array.from(RiverOpenSidebarMap.values()).length < tempPopupsRiver.length
    ) {
      const tempRemoveItem: RiverDetails[] = tempPopupsRiver.filter(
        (item) =>
          !Array.from(RiverOpenSidebarMap.values()).some(
            (changeList) => changeList.sensorId === item.sensorId
          )
      );
      setTempPopupsRiver((prevState) =>
        prevState.filter((item) => item.sensorId !== tempRemoveItem[0].sensorId)
      );
    }
  }, [riverMapEntries.length]);

  // Cyclones
  const [tempPopupsCycloneSim, setTempPopupsCycloneSim] = useState<
    PopupsListType[]
  >(props.popups);
  const [keyCycloneSim, setKeyCycloneSim] = useState<number>(0);

  useEffect(() => {
    if (props.popups.length > tempPopupsCycloneSim.length) {
      const extraObject = props.popups.filter(
        (obj) => !tempPopupsCycloneSim.some((item) => item.id === obj.id)
      );
      tempPopupsCycloneSim.unshift(extraObject[0]);
    } else if (props.popups.length < tempPopupsCycloneSim.length) {
      const tempRemoveItem: PopupsListType[] = tempPopupsCycloneSim.filter(
        (item) => !props.popups.some((changeList) => changeList.id === item.id)
      );
      setTempPopupsCycloneSim((prevState) =>
        prevState.filter((item) => item.id !== tempRemoveItem[0].id)
      );
    }
  }, [props.popups]);

  // Atmospheric River
  const [tempPopupsAtmosphericRiverSim, setTempPopupsAtmosphericRiverSim] =
    useState<PopupsListType[]>(props.popups);
  const [keyAtmosphericRiverSim, setKeyAtmosphericRiverSim] =
    useState<number>(0);

  useEffect(() => {
    if (props.popups.length > tempPopupsAtmosphericRiverSim.length) {
      const extraObject = props.popups.filter(
        (obj) =>
          !tempPopupsAtmosphericRiverSim.some((item) => item.id === obj.id)
      );
      tempPopupsAtmosphericRiverSim.unshift(extraObject[0]);
    } else if (props.popups.length < tempPopupsAtmosphericRiverSim.length) {
      const tempRemoveItem: PopupsListType[] =
        tempPopupsAtmosphericRiverSim.filter(
          (item) =>
            !props.popups.some((changeList) => changeList.id === item.id)
        );
      setTempPopupsAtmosphericRiverSim((prevState) =>
        prevState.filter((item) => item.id !== tempRemoveItem[0].id)
      );
    }
  }, [props.popups]);

  // Tornado
  const [tempPopupsTornadoSim, setTempPopupsTornadoSim] = useState<
    PopupsListType[]
  >(props.popups);
  const [keyTornadoSim, setKeyTornadoSim] = useState<number>(0);

  useEffect(() => {
    if (props.popups.length > tempPopupsTornadoSim.length) {
      const extraObject = props.popups.filter(
        (obj) => !tempPopupsTornadoSim.some((item) => item.id === obj.id)
      );
      tempPopupsTornadoSim.unshift(extraObject[0]);
    } else if (props.popups.length < tempPopupsTornadoSim.length) {
      const tempRemoveItem: PopupsListType[] = tempPopupsTornadoSim.filter(
        (item) => !props.popups.some((changeList) => changeList.id === item.id)
      );
      setTempPopupsTornadoSim((prevState) =>
        prevState.filter((item) => item.id !== tempRemoveItem[0].id)
      );
    }
  }, [props.popups]);

  // Drought
  const [tempPopupsDroughtSim, setTempPopupsDroughtSim] = useState<
    PopupsListType[]
  >(props.popups);
  const [keyDroughtSim, setKeyDroughtSim] = useState<number>(0);

  useEffect(() => {
    if (props.popups.length > tempPopupsDroughtSim.length) {
      const extraObject = props.popups.filter(
        (obj) => !tempPopupsDroughtSim.some((item) => item.id === obj.id)
      );
      tempPopupsDroughtSim.unshift(extraObject[0]);
    } else if (props.popups.length < tempPopupsDroughtSim.length) {
      const tempRemoveItem: PopupsListType[] = tempPopupsDroughtSim.filter(
        (item) => !props.popups.some((changeList) => changeList.id === item.id)
      );
      setTempPopupsDroughtSim((prevState) =>
        prevState.filter((item) => item.id !== tempRemoveItem[0].id)
      );
    }
  }, [props.popups]);

  // Jest Streams
  const [tempPopupsJestStreamsSim, setTempPopupsJestStreamsSim] = useState<
    PopupsListType[]
  >(props.popups);
  const [keyJestStreamsSim, setKeyJestStreamsSim] = useState<number>(0);

  useEffect(() => {
    if (props.popups.length > tempPopupsJestStreamsSim.length) {
      const extraObject = props.popups.filter(
        (obj) => !tempPopupsJestStreamsSim.some((item) => item.id === obj.id)
      );
      tempPopupsJestStreamsSim.unshift(extraObject[0]);
    } else if (props.popups.length < tempPopupsJestStreamsSim.length) {
      const tempRemoveItem: PopupsListType[] = tempPopupsJestStreamsSim.filter(
        (item) => !props.popups.some((changeList) => changeList.id === item.id)
      );
      setTempPopupsJestStreamsSim((prevState) =>
        prevState.filter((item) => item.id !== tempRemoveItem[0].id)
      );
    }
  }, [props.popups]);

  // Storm surge
  const [tempPopupsStormSurgeSim, setTempPopupsStormSurgeSim] = useState<
    PopupsListType[]
  >(props.popups);
  const [keyStormSurgeSim, setKeyStormSurgeSim] = useState<number>(0);

  useEffect(() => {
    if (props.popups.length > tempPopupsStormSurgeSim.length) {
      const extraObject = props.popups.filter(
        (obj) => !tempPopupsStormSurgeSim.some((item) => item.id === obj.id)
      );
      tempPopupsStormSurgeSim.unshift(extraObject[0]);
    } else if (props.popups.length < tempPopupsStormSurgeSim.length) {
      const tempRemoveItem: PopupsListType[] = tempPopupsStormSurgeSim.filter(
        (item) => !props.popups.some((changeList) => changeList.id === item.id)
      );
      setTempPopupsStormSurgeSim((prevState) =>
        prevState.filter((item) => item.id !== tempRemoveItem[0].id)
      );
    }
  }, [props.popups]);

  // Dust surge
  const [tempPopupsDustSurgeSim, setTempPopupsDustSurgeSim] = useState<
    PopupsListType[]
  >(props.popups);
  const [keyDustSurgeSim, setKeyDustSurgeSim] = useState<number>(0);

  useEffect(() => {
    if (props.popups.length > tempPopupsDustSurgeSim.length) {
      const extraObject = props.popups.filter(
        (obj) => !tempPopupsDustSurgeSim.some((item) => item.id === obj.id)
      );
      tempPopupsDustSurgeSim.unshift(extraObject[0]);
    } else if (props.popups.length < tempPopupsDustSurgeSim.length) {
      const tempRemoveItem: PopupsListType[] = tempPopupsDustSurgeSim.filter(
        (item) => !props.popups.some((changeList) => changeList.id === item.id)
      );
      setTempPopupsDustSurgeSim((prevState) =>
        prevState.filter((item) => item.id !== tempRemoveItem[0].id)
      );
    }
  }, [props.popups]);

  const refreshGrid = () => {
    setKeyEW((prevState) => prevState + 1);
    setKeyRiver((prevState) => prevState + 1);
    setKeyAir((prevState) => prevState + 1);
    setKeyHz((prevState) => prevState + 1);
    // setKeyHR(prevState => prevState + 1)
    setKeySim((prevState) => prevState + 1);
    setKeyInfo((prevState) => prevState + 1);
    setKeyDetail((prevState) => prevState + 1);
    setKeySeverity((prevState) => prevState + 1);
    setKeyRain((prevState) => prevState + 1);

    setKeyCycloneSim((prevState) => prevState + 1); /* Simulation new start */
    setKeyAtmosphericRiverSim((prevState) => prevState + 1);
    setKeyTornadoSim((prevState) => prevState + 1);
    setKeyDroughtSim((prevState) => prevState + 1);
    setKeyJestStreamsSim((prevState) => prevState + 1);
    setKeyStormSurgeSim((prevState) => prevState + 1);
    setKeyDustSurgeSim((prevState) => prevState + 1);
  };

  const removeItem = (id: string, type: ItemTypes) => {
    if (type === "ew") {
      const tempIndex: Layout = lastChangeLayoutEW.find((obj) => obj.i === id)!;

      if (tempIndex) {
        removeItemIndexEW.push({
          index: tempIndex.y,
          object: tempPopupsEW.find((obj) => obj.active_pcode === id)!,
        });
        setTempPopupsEW((prevState) =>
          prevState.filter((popup) => popup.active_pcode !== id)
        );
      }
    } else if (type === "air") {
      const tempIndex: Layout = lastChangeLayoutAir.find(
        (obj) => obj.i === id
      )!;
      if (tempIndex) {
        removeItemIndexAir.push({
          index: tempIndex.y,
          object: tempPopupsAir.find((obj) => obj.sensorId === id)!,
        });
        setTempPopupsAir((prevState) =>
          prevState.filter((popup) => popup.sensorId !== id)
        );
      }
    } else if (type === "rain") {
      const tempIndex: Layout = lastChangeLayoutRain.find(
        (obj) => obj.i === id
      )!;
      if (tempIndex) {
        removeItemIndexRain.push({
          index: tempIndex.y,
          object: tempPopupsRain.find((obj) => obj.sensorId === id)!,
        });
        setTempPopupsRain((prevState) =>
          prevState.filter((popup) => popup.sensorId !== id)
        );
      }
    } else if (type === "river") {
      const tempIndex: Layout = lastChangeLayoutRiver.find(
        (obj) => obj.i === id
      )!;
      if (tempIndex) {
        removeItemIndexRiver.push({
          index: tempIndex.y,
          object: tempPopupsRiver.find((obj) => obj.sensorId === id)!,
        });
        setTempPopupsRiver((prevState) =>
          prevState.filter((popup) => popup.sensorId !== id)
        );
      }
    } else if (type === "hz") {
      const tempIndex: Layout = lastChangeLayoutHz.find((obj) => obj.i === id)!;

      if (tempIndex) {
        removeItemIndexHz.push({
          index: tempIndex.y,
          object: tempPopupsHz.find((obj) => obj.sensorId === id)!,
        });
        setTempPopupsHz((prevState) =>
          prevState.filter((popup) => popup.sensorId !== id)
        );
      }
    } else if (type === "simulation") {
      setTempPopupSimulation((prevState) =>
        prevState.filter((popup) => popup.id !== id)
      );
      const tempGridLayout: Layout[] = tempPopupSimulation.map(
        (item, index) => ({
          i: item.id,
          x: 0,
          y: index,
          w: 1,
          h: 1,
        })
      );
      setTempLayoutHR(tempGridLayout);
    } else if (type === "info") {
      setTempPopupInfo((prevState) =>
        prevState.filter((popup) => popup.id !== id)
      );
      const tempGridLayout: Layout[] = tempPopupInfo.map((item, index) => ({
        i: item.id,
        x: 0,
        y: index,
        w: 1,
        h: 1,
      }));
      setTempLayoutInfo(tempGridLayout);
    } else if (type === "sumDetail") {
      setTempSumDetails((prevState) =>
        prevState.filter((popup) => popup.id !== id)
      );
      const tempGridLayout: Layout[] = tempSumDetails.map((item, index) => ({
        i: item.id,
        x: 0,
        y: index,
        w: 1,
        h: 1,
      }));
      setSumDetail(tempGridLayout);
    } else if (type === "sumServerity") {
      setTempSumSeverity((prevState) =>
        prevState.filter((popup) => popup.id !== id)
      );
      const tempGridLayout: Layout[] = tempSumSeverity.map((item, index) => ({
        i: item.id,
        x: 0,
        y: index,
        w: 1,
        h: 1,
      }));
      setSumSeverity(tempGridLayout);
    } else if (type === "cyclone_sim") {
      const tempIndex: Layout = lastChangeLayoutCycloneSim.find(
        (obj) => obj.i === id
      )!;

      if (tempIndex) {
        removeItemIndexCycloneSim.push({
          index: tempIndex.y,
          object: tempPopupsCycloneSim.find((obj) => obj.id === id)!,
        });
        setTempPopupsCycloneSim((prevState) =>
          prevState.filter((popup) => popup.id !== id)
        );
      }
    } else if (type === "atmospheric_river") {
      const tempIndex: Layout = lastChangeLayoutAtmosphericRiverSim.find(
        (obj) => obj.i === id
      )!;

      if (tempIndex) {
        removeItemIndexAtmosphericRiverSim.push({
          index: tempIndex.y,
          object: tempPopupsAtmosphericRiverSim.find((obj) => obj.id === id)!,
        });
        setTempPopupsAtmosphericRiverSim((prevState) =>
          prevState.filter((popup) => popup.id !== id)
        );
      }
    } else if (type === "tornado") {
      const tempIndex: Layout = lastChangeLayoutTornadoSim.find(
        (obj) => obj.i === id
      )!;

      if (tempIndex) {
        removeItemIndexTornadoSim.push({
          index: tempIndex.y,
          object: tempPopupsTornadoSim.find((obj) => obj.id === id)!,
        });
        setTempPopupsTornadoSim((prevState) =>
          prevState.filter((popup) => popup.id !== id)
        );
      }
    } else if (type === "droughts") {
      const tempIndex: Layout = lastChangeLayoutDroughtSim.find(
        (obj) => obj.i === id
      )!;

      if (tempIndex) {
        removeItemIndexDroughtSim.push({
          index: tempIndex.y,
          object: tempPopupsDroughtSim.find((obj) => obj.id === id)!,
        });
        setTempPopupsDroughtSim((prevState) =>
          prevState.filter((popup) => popup.id !== id)
        );
      }
    } else if (type === "JetStream") {
      const tempIndex: Layout = lastChangeLayoutJestStreamsSim.find(
        (obj) => obj.i === id
      )!;

      if (tempIndex) {
        removeItemIndexJestStreamsSim.push({
          index: tempIndex.y,
          object: tempPopupsJestStreamsSim.find((obj) => obj.id === id)!,
        });
        setTempPopupsJestStreamsSim((prevState) =>
          prevState.filter((popup) => popup.id !== id)
        );
      }
    } else if (type === "stormSurges") {
      const tempIndex: Layout = lastChangeLayoutStormSurgeSim.find(
        (obj) => obj.i === id
      )!;

      if (tempIndex) {
        removeItemIndexStormSurgeSim.push({
          index: tempIndex.y,
          object: tempPopupsStormSurgeSim.find((obj) => obj.id === id)!,
        });
        setTempPopupsStormSurgeSim((prevState) =>
          prevState.filter((popup) => popup.id !== id)
        );
      }
    } else if (type === "dustSurges") {
      const tempIndex: Layout = lastChangeLayoutDustSurgeSim.find(
        (obj) => obj.i === id
      )!;

      if (tempIndex) {
        removeItemIndexDustSurgeSim.push({
          index: tempIndex.y,
          object: tempPopupsDustSurgeSim.find((obj) => obj.id === id)!,
        });
        setTempPopupsDustSurgeSim((prevState) =>
          prevState.filter((popup) => popup.id !== id)
        );
      }
    }
  };

  const addItem = (id: string, type: ItemTypes) => {
    if (type === "ew") {
      const tempItem = tempPopupsEW.find((obj) => obj.active_pcode === id);
      if (tempItem) {
        const tempItemIndex: number = removeItemIndexEW.find(
          (obj) => obj.object.active_pcode === tempItem.active_pcode
        )?.index!; //LATEST UPDATE: New start
        removeItemIndexEW = removeItemIndexEW.filter(
          (item) => item.object.active_pcode !== id
        );
        setTempPopupsEW((prevState) => {
          const updatedList = [...prevState];
          updatedList.splice(tempItemIndex, 0, tempItem);
          return updatedList;
        });
      }
    } else if (type === "air") {
      const tempItem = tempPopupsAir.find((obj) => obj.sensorId === id);
      if (tempItem) {
        const tempItemIndex: number = removeItemIndexAir.find(
          (obj) => obj.object.sensorId === tempItem.sensorId
        )?.index!; //LATEST UPDATE: New start
        removeItemIndexAir = removeItemIndexAir.filter(
          (item) => item.object.sensorId !== id
        );
        setTempPopupsAir((prevState) => {
          const updatedList = [...prevState];
          updatedList.splice(tempItemIndex, 0, tempItem);
          return updatedList;
        });
      }
    } else if (type === "rain") {
      const tempItem = tempPopupsRain.find((obj) => obj.sensorId === id);
      if (tempItem) {
        const tempItemIndex: number = removeItemIndexRain.find(
          (obj) => obj.object.sensorId === tempItem.sensorId
        )?.index!; //LATEST UPDATE: New start
        removeItemIndexRain = removeItemIndexRain.filter(
          (item) => item.object.sensorId !== id
        );
        setTempPopupsRain((prevState) => {
          const updatedList = [...prevState];
          updatedList.splice(tempItemIndex, 0, tempItem);
          return updatedList;
        });
      }
    } else if (type === "river") {
      const tempItem = tempPopupsRiver.find((obj) => obj.sensorId === id);
      if (tempItem) {
        const tempItemIndex: number = removeItemIndexRiver.find(
          (obj) => obj.object.sensorId === tempItem.sensorId
        )?.index!; //LATEST UPDATE: New start
        removeItemIndexRiver = removeItemIndexRiver.filter(
          (item) => item.object.sensorId !== id
        );
        setTempPopupsRiver((prevState) => {
          const updatedList = [...prevState];
          updatedList.splice(tempItemIndex, 0, tempItem);
          return updatedList;
        });
      }
    } else if (type === "hz") {
      const tempItem = tempPopupsHz.find((obj) => obj.sensorId === id);
      if (tempItem) {
        const tempItemIndex: number = removeItemIndexHz.find(
          (obj) => obj.object.sensorId === tempItem.sensorId
        )?.index!; //LATEST UPDATE: New start
        removeItemIndexHz = removeItemIndexHz.filter(
          (item) => item.object.sensorId !== id
        );
        setTempPopupsHz((prevState) => {
          const updatedList = [...prevState];
          updatedList.splice(tempItemIndex, 0, tempItem);
          return updatedList;
        });
      }
    } else if (type === "simulation") {
      const tempItem = tempPopupSimulation.find((obj) => obj.id === id);
      if (tempItem) {
        setTempPopupSimulation((prevState) => [tempItem, ...prevState]);
        const tempGridLayout: Layout[] = tempPopupSimulation.map(
          (item, index) => ({
            i: item.id,
            x: 0,
            y: index,
            w: 1,
            h: 1,
          })
        );
        setTempLayoutSimulation(tempGridLayout);
      }
    } else if (type === "info") {
      const tempItem = tempPopupInfo.find((obj) => obj.id === id);
      if (tempItem) {
        setTempPopupInfo((prevState) => [tempItem, ...prevState]);
        const tempGridLayout: Layout[] = tempPopupInfo.map((item, index) => ({
          i: item.id,
          x: 0,
          y: index,
          w: 1,
          h: 1,
        }));
        setTempLayoutInfo(tempGridLayout);
      }
    } else if (type === "sumDetail") {
      const tempItem = tempSumDetails.find((obj) => obj.id === id);
      if (tempItem) {
        setTempSumDetails((prevState) => [tempItem, ...prevState]);
        const tempGridLayout: Layout[] = tempSumDetails.map((item, index) => ({
          i: item.id,
          x: 0,
          y: index,
          w: 1,
          h: 1,
        }));
        setSumDetail(tempGridLayout);
      }
      setSumDetailAdd(true);
    } else if (type === "sumServerity") {
      const tempItem = tempSumSeverity.find((obj) => obj.id === id);
      if (tempItem) {
        setTempSumSeverity((prevState) => [tempItem, ...prevState]);
        const tempGridLayout: Layout[] = tempSumSeverity.map((item, index) => ({
          i: item.id,
          x: 0,
          y: index,
          w: 1,
          h: 1,
        }));
        setSumSeverity(tempGridLayout);
      }
      setSumSeverityAdd(true);
    } else if (type === "cyclone_sim") {

      const tempItem = props.popups.find((obj) => obj.id === id);
      if (tempItem) {
        const tempItemIndex: number = removeItemIndexCycloneSim.find(
          (obj) => obj.object.id === tempItem.id
        )?.index!; //LATEST UPDATE: New start
        removeItemIndexCycloneSim = removeItemIndexCycloneSim.filter(
          (item) => item.object.id !== id
        );
        setTempPopupsCycloneSim((prevState) => {
          const updatedList = [...prevState];
          updatedList.splice(tempItemIndex, 0, tempItem);
          return updatedList;
        });
      }
    } else if (type === "atmospheric_river") {
 
      const tempItem = props.popups.find((obj) => obj.id === id);
      if (tempItem) {
        const tempItemIndex: number = removeItemIndexAtmosphericRiverSim.find(
          (obj) => obj.object.id === tempItem.id
        )?.index!; //LATEST UPDATE: New start
        removeItemIndexAtmosphericRiverSim =
          removeItemIndexAtmosphericRiverSim.filter(
            (item) => item.object.id !== id
          );
        setTempPopupsAtmosphericRiverSim((prevState) => {
          const updatedList = [...prevState];
          updatedList.splice(tempItemIndex, 0, tempItem);
          return updatedList;
        });
      }
    } else if (type === "tornado") {
      const tempItem = props.popups.find((obj) => obj.id === id);
      if (tempItem) {
        const tempItemIndex: number = removeItemIndexTornadoSim.find(
          (obj) => obj.object.id === tempItem.id
        )?.index!; //LATEST UPDATE: New start
        removeItemIndexTornadoSim = removeItemIndexTornadoSim.filter(
          (item) => item.object.id !== id
        );
        setTempPopupsTornadoSim((prevState) => {
          const updatedList = [...prevState];
          updatedList.splice(tempItemIndex, 0, tempItem);
          return updatedList;
        });
      }
    } else if (type === "droughts") {
      const tempItem = props.popups.find((obj) => obj.id === id);
      if (tempItem) {
        const tempItemIndex: number = removeItemIndexDroughtSim.find(
          (obj) => obj.object.id === tempItem.id
        )?.index!; //LATEST UPDATE: New start
        removeItemIndexDroughtSim = removeItemIndexDroughtSim.filter(
          (item) => item.object.id !== id
        );
        setTempPopupsDroughtSim((prevState) => {
          const updatedList = [...prevState];
          updatedList.splice(tempItemIndex, 0, tempItem);
          return updatedList;
        });
      }
    } else if (type === "JetStream") {
      const tempItem = props.popups.find((obj) => obj.id === id);
      if (tempItem) {
        const tempItemIndex: number = removeItemIndexJestStreamsSim.find(
          (obj) => obj.object.id === tempItem.id
        )?.index!; //LATEST UPDATE: New start
        removeItemIndexJestStreamsSim = removeItemIndexJestStreamsSim.filter(
          (item) => item.object.id !== id
        );
        setTempPopupsJestStreamsSim((prevState) => {
          const updatedList = [...prevState];
          updatedList.splice(tempItemIndex, 0, tempItem);
          return updatedList;
        });
      }
    } else if (type === "stormSurges") {
      const tempItem = props.popups.find((obj) => obj.id === id);
      if (tempItem) {
        const tempItemIndex: number = removeItemIndexStormSurgeSim.find(
          (obj) => obj.object.id === tempItem.id
        )?.index!; //LATEST UPDATE: New start
        removeItemIndexStormSurgeSim = removeItemIndexStormSurgeSim.filter(
          (item) => item.object.id !== id
        );
        setTempPopupsStormSurgeSim((prevState) => {
          const updatedList = [...prevState];
          updatedList.splice(tempItemIndex, 0, tempItem);
          return updatedList;
        });
      }
    } else if (type === "dustSurges") {
      const tempItem = props.popups.find((obj) => obj.id === id);
      if (tempItem) {
        const tempItemIndex: number = removeItemIndexDustSurgeSim.find(
          (obj) => obj.object.id === tempItem.id
        )?.index!; //LATEST UPDATE: New start
        removeItemIndexDustSurgeSim = removeItemIndexDustSurgeSim.filter(
          (item) => item.object.id !== id
        );
        setTempPopupsDustSurgeSim((prevState) => {
          const updatedList = [...prevState];
          updatedList.splice(tempItemIndex, 0, tempItem);
          return updatedList;
        });
      }
    }
  };

  const title = (sensorType: string): string => {
    if (sensorType === "riverSensor" && tempPopupsRiver.length !== 0) {
      return "River Sensor";
    } else if (
      sensorType === "airQualitySensor" &&
      tempPopupsAir.length !== 0
    ) {
      return "Air Quality";
    } else if (sensorType === "rainfallSensor" && tempPopupsRain.length !== 0) {
      return "Rainfall";
    } else if (sensorType === "ewsLocation" && tempPopupsEW.length !== 0) {
      return "Early Warning";
    } else if (sensorType === "hzLocation" && tempPopupsHz.length !== 0) {
      return "Reported Incident";
    } else if (sensorType === "") {
      if (isSideMenuSimulationStatus) {
        return "Flood Simulation";
      } else if (isSideMenuSimulationCycloneSimStatus) {
        return "Cyclone Simulation";
      } else if (isSideMenuSimulationAtmosphericRiverSimStatus) {
        return "Atmospheric River Simulation";
      } else if (isSideMenuSimulationTornadoSimStatus) {
        return "Tornado Simulation";
      } else if (isSideMenuSimulationDroughtSimStatus) {
        return "Drought Simulation";
      } else if (isSideMenuSimulationJestStreamsSimStatus) {
        return "Jest Streams Simulation";
      } else if (isSideMenuSimulationStormSurgeSimStatus) {
        return "Storm Surge Simulation";
      } else if (isSideMenuSimulationDustSurgeSimStatus) {
        return "Dust Surge Simulation";
      } else if (
        props.isSummaryMoreDetailsOpen ||
        props.isEwsServerityOpen ||
        props.detailsByTypeOpen
      ) {
        return "Summery";
      }
    }
    return "Menu";
  };

  /* const [isSideMenuSimulationCycloneSimStatus, setIsSideMenuSimulationCycloneSimStatus] =
    useState<boolean>(false);

    const [isSideMenuSimulationAtmosphericRiverSimStatus, setIsSideMenuSimulationAtmosphericRiverSimStatus] =
    useState<boolean>(false);

    const [isSideMenuSimulationTornadoSimStatus, setIsSideMenuSimulationTornadoSimStatus] =
    useState<boolean>(false);

    const [isSideMenuSimulationDroughtSimStatus, setIsSideMenuSimulationDroughtSimStatus] =
    useState<boolean>(false);

    const [isSideMenuSimulationJestStreamsSimStatus, setIsSideMenuSimulationJestStreamsSimStatus] =
    useState<boolean>(false);

    const [isSideMenuSimulationStormSurgeSimStatus, setIsSideMenuSimulationStormSurgeSimStatus] =
    useState<boolean>(false);

    const [isSideMenuSimulationDustSurgeSimStatus, setIsSideMenuSimulationDustSurgeSimStatus] =
    useState<boolean>(false); */

  useEffect(() => {
    refreshGrid();
  }, [
    tempPopupsEW,
    tempPopupsHz,
    tempPopupsAir,
    tempPopupsRain,
    tempPopupsRiver,
    // tempLayoutEW,
    // tempLayoutRiver,
    // tempLayoutAir,
    // tempLayoutHz,
    tempLayoutHR,
    tempPopupSimulation,
    tempPopupInfo,
    tempSumDetails,
    tempSumSeverity,
    tempPopupsCycloneSim,
    tempPopupsAtmosphericRiverSim,
    tempPopupsTornadoSim,
    tempPopupsDroughtSim,
    tempPopupsJestStreamsSim,
    tempPopupsStormSurgeSim,
    tempPopupsDustSurgeSim,
  ]);

  useEffect(() => {
    if (
      tempPopupsRiver.length === 0 &&
      tempPopupsAir.length === 0 &&
      tempPopupsEW.length === 0 &&
      tempPopupsHz.length === 0 &&
      tempPopupsRain.length === 0 &&
      !props.isSummaryMoreDetailsOpen &&
      !props.isEwsServerityOpen &&
      !props.detailsByTypeOpen &&
      !isSideMenuSimulationStatus &&
      !isSideMenuSimulationDroughtSimStatus &&
      !isSideMenuSimulationJestStreamsSimStatus &&
      !isSideMenuSimulationDustSurgeSimStatus &&
      !isSideMenuSimulationStormSurgeSimStatus &&
      !isSideMenuSimulationDroughtSimStatus &&
      !isSideMenuSimulationTornadoSimStatus &&
      !isSideMenuSimulationAtmosphericRiverSimStatus
    ) {
      props.closeModular();
    }

    if (!props.isSummaryMoreDetailsOpen) {
      setTempPopupInfo(popupInfo);
    }
    if (!props.detailsByTypeOpen) {
      setTempSumDetails(sumDetails);
    }
    if (!props.isEwsServerityOpen) {
      setTempSumSeverity(sumServerity);
    }
  }, [
    tempPopupsRiver,
    tempPopupsAir,
    tempPopupsEW,
    tempPopupsHz,
    tempPopupsRain,
    props.isSummaryMoreDetailsOpen,
    props.isEwsServerityOpen,
    props.detailsByTypeOpen,
    isSideMenuSimulationStatus,
    isSideMenuSimulationDroughtSimStatus,
    isSideMenuSimulationJestStreamsSimStatus,
    isSideMenuSimulationDustSurgeSimStatus,
    isSideMenuSimulationStormSurgeSimStatus,
    isSideMenuSimulationDroughtSimStatus,
    isSideMenuSimulationTornadoSimStatus,
    isSideMenuSimulationAtmosphericRiverSimStatus,
  ]);

  useEffect(() => {}, [SumSeverityAdd]);

  useEffect(() => {}, [SumDetailAdd]);

  const onCloseDetailPopup = () => {
    setSumDetailAdd(false);
    props.closeAllSum();
  };

  const onCloseSeverityPopup = () => {
    setSumSeverityAdd(false);
    props.closeAllSum();
  };

  const handleLayoutChange = (newLayout: Layout[]) => {
    lastChangeLayoutEW = newLayout;
  };

  const handleLayoutChangeHz = (newLayout: Layout[]) => {
    lastChangeLayoutHz = newLayout;
  };

  const handleLayoutChangeAir = (newLayout: Layout[]) => {
    lastChangeLayoutAir = newLayout;
  };

  const handleLayoutChangeRiver = (newLayout: Layout[]) => {
    lastChangeLayoutRiver = newLayout;
  };

  const handleLayoutChangeRain = (newLayout: Layout[]) => {
    lastChangeLayoutRain = newLayout;
  };

  const handleLayoutChangeCycloneSim = (newLayout: Layout[]) => {
    lastChangeLayoutCycloneSim = newLayout;
  };

  const handleLayoutChangeAtmoRiverSim = (newLayout: Layout[]) => {
    lastChangeLayoutAtmosphericRiverSim = newLayout;
  };

  const handleLayoutChangeTornadoSim = (newLayout: Layout[]) => {
    lastChangeLayoutTornadoSim = newLayout;
  };

  const handleLayoutChangeDroughtSim = (newLayout: Layout[]) => {
    lastChangeLayoutDroughtSim = newLayout;
  };

  const handleLayoutChangeJestStreamSim = (newLayout: Layout[]) => {
    lastChangeLayoutJestStreamsSim = newLayout;
  };

  const handleLayoutChangeStormeSurgeSim = (newLayout: Layout[]) => {
    lastChangeLayoutStormSurgeSim = newLayout;
  };

  const handleLayoutChangeDustSurgeSim = (newLayout: Layout[]) => {
    lastChangeLayoutDustSurgeSim = newLayout;
  };

  return (
    <div
      className={`sideMenuWrapper`}
      id="side-menu-wrapper"
      style={{ transform: `translateX(${props.menuStatus ? "0" : "100%"})` }}
      ref={sideMenuElementRef}
    >
      <div className={`dragger`} ref={draggerElementRef}></div>
      <div className={`dataWrapper`}>
        {/* Close button */}
        {props.getModularOpened === "modularOpened" && (
          <span className={`side-menu-title`}>
            {title(props.getSensorType)}
          </span>
        )}
        <div className={`button-container`}>
          {props.getModularOpened === "modularOpened" && (
            <>
              {singleWindow && (
                <img
                  className={"buttons"}
                  src={singleWindowIcon}
                  onClick={(e) => handleSingleWindowClick()}
                  onTouchEnd={(e) => handleSingleWindowClick()}
                  alt=""
                />
              )}
              {multiWindow && (
                <img
                  className={"buttons"}
                  src={multiWindowIcon}
                  onClick={(e) => handleMultiWindowClick()}
                  onTouchEnd={(e) => handleMultiWindowClick()}
                  alt=""
                />
              )}
            </>
          )}
          <img
            className={"buttons"}
            src={closeIco}
            onClick={(e) => props.setMenuStatus(false)}
            onTouchEnd={(e) => props.setMenuStatus(false)}
            alt=""
          />
        </div>
        {/* Back button */}
        {props.getModularOpened === "modularOpened" && (
          <ArrowBackIcon
            onClick={handleBackButtonClick}
            onTouchStart={handleBackButtonClick}
            className={`backButton`}
          />
        )}
        {props.getModularOpened === "notOpenedModular" &&
          ((tempPopupsRiver.length > 0 &&
            props.getSensorType === "riverSensor") ||
            (tempPopupsRain.length > 0 &&
              props.getSensorType === "rainfallSensor") ||
            (tempPopupsAir.length > 0 &&
              props.getSensorType === "airQualitySensor") ||
            (tempPopupsEW.length > 0 &&
              props.getSensorType === "ewsLocation") ||
            (tempPopupsHz.length > 0 &&
              props.getSensorType === "hzLocation")) &&
          forwardIcon === false && (
            <ArrowForwardIcon
              onClick={handleForwardButtonClick}
              onTouchStart={handleForwardButtonClick}
              className={`backButton`}
            />
          )}

        {/* User data container */}
        {props.getModularOpened === "notOpenedModular" && (
          <>
            <div className={`userDetailsWrapper`}>
              <div className={`user-image`}>
                <img src={userIcon} alt="" />
              </div>
              <div className={`details-box`}>
                <span className={`username`}>Admin</span>
                <span className={`last-login-date`}>
                  Last Login: {loginTime}
                </span>
                <button onClick={logout} onTouchStart={logout}>
                  logout
                </button>
              </div>
            </div>
            {/* Menu container */}
            <div className={`menuWrapper`}>
              <div className="parentItemContainer">
                <div
                  className={`titleWrapper`}
                  onClick={(e) => setIsLayersOpen((prevState) => !prevState)}
                  onTouchStart={(e) =>
                    setIsLayersOpen((prevState) => !prevState)
                  }
                >
                  <span className={`title`}>layers</span>
                  {isLayersOpen ? (
                    <UpIcon
                      className={`icon`}
                      bgColor={"none"}
                      width={"1rem"}
                      lineColor={"var(--text-color)"}
                    />
                  ) : (
                    <DownIcon
                      className={`icon`}
                      bgColor={"none"}
                      width={"1rem"}
                      lineColor={"var(--text-color)"}
                    />
                  )}
                </div>
                <div
                  className={`subItemWrapperLayers`}
                  style={{ display: isLayersOpen ? "block" : "none" }}
                >
                  <LayersWindow />
                </div>
              </div>
              {menuItems.map((item, index) => (
                <div key={index} className="parentItemContainer">
                  <div
                    className={`titleWrapper`}
                    onClick={(e) => handleParentItemClick(item.itemName)}
                    onTouchStart={(e) => handleParentItemClick(item.itemName)}
                  >
                    <span className={`title`}>{item.itemName}</span>
                    {item.children.length > 0 &&
                      (item.status ? (
                        <UpIcon
                          className={`icon`}
                          bgColor={"none"}
                          width={"1rem"}
                          lineColor={"var(--text-color)"}
                        />
                      ) : (
                        <DownIcon
                          className={`icon`}
                          bgColor={"none"}
                          width={"1rem"}
                          lineColor={"var(--text-color)"}
                        />
                      ))}
                  </div>
                  {item.children.length > 0 && item.status && (
                    <div className={`subItemWrapper`}>
                      {item.children.map((subitem, index) => (
                        <div
                          className={`subItemWrapper`}
                          onClick={(e) => {
                            handleThemeButtonClick(
                              e,
                              item.itemName,
                              subitem.subItemName
                            );
                          }}
                          onTouchStart={(e) => {
                            handleThemeButtonClick(
                              e,
                              item.itemName,
                              subitem.subItemName
                            );
                          }}
                        >
                          {subitem.color && (
                            <div
                              className={`colorBox ${
                                subitem.status ? "selected" : ""
                              }`}
                              style={{ backgroundColor: `${subitem.color}` }}
                            ></div>
                          )}
                          {subitem.img && (
                            <div
                              className={`colorBox ${
                                subitem.status ? "selected" : ""
                              }`}
                            >
                              {subitem.img}
                            </div>
                          )}
                          <span key={index}>{subitem.subItemName}</span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))}
              <div className="parentItemContainer">
                <div
                  className={`titleWrapper`}
                  onClick={(e) =>
                    setIsExtremeWeatherEventsOpen((prevState) => !prevState)
                  }
                  onTouchStart={(e) =>
                    setIsExtremeWeatherEventsOpen((prevState) => !prevState)
                  }
                >
                  <span className={`title`}>extreme weather events</span>
                  {isExtremeWeatherEventsOpen ? (
                    <UpIcon
                      className={`icon`}
                      bgColor={"none"}
                      width={"1rem"}
                      lineColor={"var(--text-color)"}
                    />
                  ) : (
                    <DownIcon
                      className={`icon`}
                      bgColor={"none"}
                      width={"1rem"}
                      lineColor={"var(--text-color)"}
                    />
                  )}
                </div>
                <div
                  className={`subItemWrapper`}
                  style={{
                    display: isExtremeWeatherEventsOpen ? "grid" : "none",
                  }}
                >
                  <Cyclones
                    name="Cyclones (Tropical and Extratropical)"
                    img={
                      <CycloneIcon
                        className={`layout-icon`}
                        size="1rem"
                        color="var(--text-color)"
                      />
                    }
                    timeLineHour={props.timeLineHour}
                    timeLineDate={props.timeLineDate}
                    selectModel={props.selectModel}
                  />
                  <AtmosphericRivers
                    name="Atmospheric Rivers (ARs)"
                    img={
                      <AtmosphericRiversIcon
                        className={`layout-icon`}
                        size="1rem"
                        color="var(--text-color)"
                      />
                    }
                    timeLineHour={props.timeLineHour}
                    timeLineDate={props.timeLineDate}
                    selectModel={props.selectModel}
                  />
                  <Tornados
                    name="Tornado and Severe Thunderstorm Environments"
                    img={
                      <TornadoIcon
                        className={`layout-icon`}
                        size="1rem"
                        color="var(--text-color)"
                      />
                    }
                    timeLineHour={props.timeLineHour}
                    timeLineDate={props.timeLineDate}
                    selectModel={props.selectModel}
                    clickTornado={handleThemeButtonClick}
                  />
                  <Droughts
                    name="Droughts"
                    img={
                      <DesertIcon
                        className={`layout-icon`}
                        size="1rem"
                        color="var(--text-color)"
                      />
                    }
                    timeLineHour={props.timeLineHour}
                    timeLineDate={props.timeLineDate}
                    selectModel={props.selectModel}
                  />
                  <JetStreams
                    name="Jet Streams and Upper-Level Pattern"
                    img={
                      <JetSteamIcon
                        className={`layout-icon`}
                        size="1rem"
                        color="var(--text-color)"
                      />
                    }
                    timeLineHour={props.timeLineHour}
                    timeLineDate={props.timeLineDate}
                    selectModel={props.selectModel}
                  />
                  <StormSurges
                    name="Storm Surges"
                    img={
                      <StormSurgeIcon
                        className={`layout-icon`}
                        size="1rem"
                        color="var(--text-color)"
                      />
                    }
                    timeLineHour={props.timeLineHour}
                    timeLineDate={props.timeLineDate}
                    selectModel={props.selectModel}
                  />
                  <DustStorms
                    name="Dust Storms"
                    img={
                      <SandStormIcon
                        className={`layout-icon`}
                        size="1rem"
                        color="var(--text-color)"
                      />
                    }
                    timeLineHour={props.timeLineHour}
                    timeLineDate={props.timeLineDate}
                    selectModel={props.selectModel}
                  />
                </div>
              </div>
            </div>
          </>
        )}

        {/* Popup containers */}
        {props.getModularOpened === "modularOpened" &&
          props.getSensorType === "riverSensor" &&
          singleWindow === false && (
            <div className={`popupWrappers`}>
              <GridLayout
                key={keyRiver}
                className="layout"
                onLayoutChange={handleLayoutChangeRiver}
                cols={1}
                rowHeight={800}
                width={sideMenuWidth - 15}
                isResizable={false}
                draggableCancel=".no-drag"
              >
                {tempPopupsRiver.map((river, index) => (
                  <div key={`${river.sensorId}`}>
                    <RiverChartPopup
                      key={`${river.sensorId}`}
                      id={river.sensorId!}
                      name={river.name!}
                      critical={river.criticalLevel!}
                      cautious={river.cautionLevel!}
                      warning={river.warningLevel!}
                      setPopups={props.setPopups}
                      widthValue={sideMenuWidth}
                      setRiverSensorRender={toggleRiverSensorRender}
                      removeItem={removeItem}
                      addItem={addItem}
                      coordinatesPopup={river.coordinates!}
                    />
                  </div>
                ))}
              </GridLayout>
            </div>
          )}

        {props.getModularOpened === "modularOpened" &&
          props.getSensorType === "riverSensor" &&
          singleWindow === true && (
            <div className={`popupWrappers`}>
              <GridLayout
                key={keyRiver}
                className="layout"
                onLayoutChange={handleLayoutChangeRiver}
                cols={1}
                rowHeight={800}
                width={sideMenuWidth - 15}
                isResizable={false}
                draggableCancel=".no-drag"
              >
                {tempPopupsRiver.slice(0, 1).map((river, index) => (
                  <div key={`${river.sensorId}`}>
                    <RiverChartPopup
                      key={`${river.sensorId}`}
                      id={river.sensorId!}
                      name={river.name!}
                      critical={river.criticalLevel!}
                      cautious={river.cautionLevel!}
                      warning={river.warningLevel!}
                      setPopups={props.setPopups}
                      widthValue={sideMenuWidth}
                      setRiverSensorRender={toggleRiverSensorRender}
                      removeItem={removeItem}
                      addItem={addItem}
                      coordinatesPopup={river.coordinates!}
                    />
                  </div>
                ))}
              </GridLayout>
            </div>
          )}

        {/* Popup containers */}
        {props.getModularOpened === "modularOpened" &&
          props.getSensorType === "airQualitySensor" &&
          singleWindow === false && (
            <div className={`popupWrappers`}>
              <GridLayout
                key={keyAir}
                className="layout"
                // layout={gridLayout}
                cols={1}
                rowHeight={680}
                width={sideMenuWidth - 15}
                isResizable={false}
                draggableCancel=".no-drag"
                onLayoutChange={handleLayoutChangeAir}
              >
                {tempPopupsAir.map((airQuality, index) => (
                  <div key={`${airQuality.sensorId}`}>
                    <SideMenuAirQualityPopup
                      key={`${airQuality.sensorId}`}
                      sensorId={airQuality.sensorId!}
                      name={airQuality.name!}
                      pm10={airQuality.pm10}
                      pm25={airQuality.pm25}
                      pm100={airQuality.pm100}
                      co2={airQuality.co2}
                      temperature={airQuality.temperature}
                      aqi={airQuality.aqi}
                      timestamp={airQuality.timestamp}
                      setPopups={props.setPopups}
                      widthValue={sideMenuWidth}
                      setAirQualityRender={toggleAirQualityRender}
                      removeItem={removeItem}
                      addItem={addItem}
                      coordinatesPopup={airQuality.coordinates!}
                    />
                  </div>
                ))}
              </GridLayout>
            </div>
          )}

        {props.getModularOpened === "modularOpened" &&
          props.getSensorType === "airQualitySensor" &&
          singleWindow === true && (
            <div className={`popupWrappers`}>
              <GridLayout
                key={keyAir}
                className="layout"
                cols={1}
                rowHeight={680}
                width={sideMenuWidth - 15}
                isResizable={false}
                draggableCancel=".no-drag"
              >
                {tempPopupsAir.slice(0, 1).map((airQuality, index) => (
                  <div key={`${airQuality.sensorId}`}>
                    <SideMenuAirQualityPopup
                      key={`${airQuality.sensorId}`}
                      sensorId={airQuality.sensorId!}
                      name={airQuality.name!}
                      pm10={airQuality.pm10}
                      pm25={airQuality.pm25}
                      pm100={airQuality.pm100}
                      co2={airQuality.co2}
                      temperature={airQuality.temperature}
                      aqi={airQuality.aqi}
                      timestamp={airQuality.timestamp}
                      setPopups={props.setPopups}
                      widthValue={sideMenuWidth}
                      setAirQualityRender={toggleAirQualityRender}
                      removeItem={removeItem}
                      addItem={addItem}
                      coordinatesPopup={airQuality.coordinates!}
                    />
                  </div>
                ))}
              </GridLayout>
            </div>
          )}

        {props.getModularOpened === "modularOpened" &&
          props.getSensorType === "rainfallSensor" &&
          singleWindow === false && (
            <div className={`popupWrappers`}>
              <GridLayout
                key={keyRain}
                className="layout"
                // layout={gridLayout}
                cols={1}
                rowHeight={680}
                width={sideMenuWidth - 15}
                isResizable={false}
                draggableCancel=".no-drag"
                onLayoutChange={handleLayoutChangeRain}
              >
                {tempPopupsRain.map((rain, index) => (
                  <div key={`${rain.sensorId}`}>
                    <SideMenuRainfallPopup
                      key={`${rain.sensorId}`}
                      id={rain.sensorId!}
                      name={rain.name!}
                      // critical={rain.criticalLevel!}
                      // cautious={rain.cautionLevel!}
                      // warning={rain.warningLevel!}
                      setPopups={props.setPopups}
                      widthValue={sideMenuWidth}
                      setRainfallRender={toggleRainfallRender}
                      removeItem={removeItem}
                      addItem={addItem}
                      coordinatesPopup={rain.coordinates!}
                    />
                  </div>
                ))}
              </GridLayout>
            </div>
          )}

        {props.getModularOpened === "modularOpened" &&
          props.getSensorType === "rainfallSensor" &&
          singleWindow === true && (
            <div className={`popupWrappers`}>
              <GridLayout
                key={keyRain}
                className="layout"
                cols={1}
                rowHeight={680}
                width={sideMenuWidth - 15}
                isResizable={false}
                draggableCancel=".no-drag"
              >
                {tempPopupsRain.slice(0, 1).map((rain, index) => (
                  <div key={`${rain.sensorId}`}>
                    <SideMenuRainfallPopup
                      key={`${rain.sensorId}`}
                      id={rain.sensorId!}
                      name={rain.name!}
                      // critical={rain.criticalLevel!}
                      // cautious={rain.cautionLevel!}
                      // warning={rain.warningLevel!}

                      setPopups={props.setPopups}
                      widthValue={sideMenuWidth}
                      setRainfallRender={toggleRainfallRender}
                      removeItem={removeItem}
                      addItem={addItem}
                      coordinatesPopup={rain.coordinates!}
                    />
                  </div>
                ))}
              </GridLayout>
            </div>
          )}

        {props.getModularOpened === "modularOpened" &&
          props.getSensorType === "ewsLocation" &&
          singleWindow === false && (
            <div className={`popupWrappers`}>
              <GridLayout
                key={keyEW}
                className="layout"
                cols={1}
                rowHeight={660}
                width={sideMenuWidth - 15}
                isResizable={false}
                draggableCancel=".no-drag"
                onLayoutChange={handleLayoutChange}
              >
                {tempPopupsEW.map((ews, index) => (
                  <div key={`${ews.active_pcode}`}>
                    <SideMenuEarlyWarningPopup
                      warningId={ews.sensorId!}
                      coordinates={ews.coordinates!}
                      adm4_en={ews.adm4_en}
                      active_pcode={ews.active_pcode}
                      end_time={ews.end_time}
                      s_desc={ews.s_desc}
                      severity_index={ews.severity_index}
                      severity={ews.severity}
                      adm4_pcode={ews.adm4_pcode}
                      adm3_pcode={ews.adm3_pcode}
                      adm3_en={ews.adm3_en}
                      adm2_pcode={ews.adm2_pcode}
                      adm2_en={ews.adm2_en}
                      active_alevel={ews.active_alevel}
                      en_desc={ews.en_desc}
                      validityPeriod={ews.validityPeriod}
                      issued_time={ews.issued_time}
                      w_status={ews.w_status}
                      w_desc={ews.w_desc}
                      w_name={ews.w_name}
                      w_type={ews.w_type}
                      adm1_en={ews.adm1_en}
                      widthValue={sideMenuWidth}
                      setEWSRender={toggleEWSRender}
                      setPopups={props.setPopups}
                      onActivePcode={handleActivePcode}
                      removeItem={removeItem}
                      addItem={addItem}
                    />
                  </div>
                ))}
              </GridLayout>
            </div>
          )}

        {props.getModularOpened === "modularOpened" &&
          props.getSensorType === "ewsLocation" &&
          singleWindow === true && (
            <div className={`popupWrappers`}>
              <GridLayout
                key={keyEW}
                className="layout"
                cols={1}
                rowHeight={660}
                width={sideMenuWidth - 15}
                isResizable={false}
                draggableCancel=".no-drag"
              >
                {tempPopupsEW.slice(0, 1).map((ews, index) => (
                  <div key={`${ews.active_pcode}`}>
                    <SideMenuEarlyWarningPopup
                      warningId={ews.sensorId!}
                      coordinates={ews.coordinates!}
                      adm4_en={ews.adm4_en}
                      active_pcode={ews.active_pcode}
                      end_time={ews.end_time}
                      s_desc={ews.s_desc}
                      severity_index={ews.severity_index}
                      severity={ews.severity}
                      adm4_pcode={ews.adm4_pcode}
                      adm3_pcode={ews.adm3_pcode}
                      adm3_en={ews.adm3_en}
                      adm2_pcode={ews.adm2_pcode}
                      adm2_en={ews.adm2_en}
                      active_alevel={ews.active_alevel}
                      en_desc={ews.en_desc}
                      validityPeriod={ews.validityPeriod}
                      issued_time={ews.issued_time}
                      w_status={ews.w_status}
                      w_desc={ews.w_desc}
                      w_name={ews.w_name}
                      w_type={ews.w_type}
                      adm1_en={ews.adm1_en}
                      widthValue={sideMenuWidth}
                      setEWSRender={toggleEWSRender}
                      setPopups={props.setPopups}
                      onActivePcode={handleActivePcode}
                      removeItem={removeItem}
                      addItem={addItem}
                    />
                  </div>
                ))}
              </GridLayout>
            </div>
          )}

        {props.getModularOpened === "modularOpened" &&
          props.getSensorType === "hzLocation" &&
          singleWindow === false && (
            <div className={`popupWrappers`}>
              <GridLayout
                key={keyHz}
                className="layout"
                cols={1}
                rowHeight={750}
                width={sideMenuWidth - 15}
                isResizable={false}
                draggableCancel=".no-drag"
                onLayoutChange={handleLayoutChangeHz}
              >
                {tempPopupsHz.map((hz, index) => (
                  <div key={`${hz.sensorId}`}>
                    <SideMenuReportedIncident
                      incidentId={hz.sensorId!}
                      adm4_en={hz.adm4_en}
                      bwater_level={hz.bwater_level}
                      end_time={hz.end_time}
                      hwater_level={hz.hwater_level}
                      img_url={hz.img_url}
                      imp_communication={hz.imp_communication}
                      imp_electricity={hz.imp_electricity}
                      imp_house={hz.imp_house}
                      imp_human={hz.imp_human}
                      imp_response={hz.imp_response}
                      imp_roadblock={hz.imp_roadblock}
                      imp_roaddamage={hz.imp_roaddamage}
                      imp_water={hz.imp_water}
                      impdes_communication={hz.impdes_communication}
                      impdes_electricity={hz.impdes_electricity}
                      impdes_house={hz.impdes_house}
                      impdes_human={hz.impdes_human}
                      impdes_roadblock={hz.impdes_roadblock}
                      impdes_roaddamage={hz.impdes_roaddamage}
                      impdes_water={hz.impdes_water}
                      issued_time={hz.issued_time}
                      occurance_date={hz.occurance_date}
                      observed_date={hz.observed_date}
                      tp_number={hz.tp_number}
                      w_desc={hz.w_desc}
                      w_name={hz.w_name}
                      w_type={hz.w_type}
                      setHzRender={toggleHzRender}
                      removeItem={removeItem}
                      addItem={addItem}
                      coordinatesPopup={hz.coordinates!}
                    />
                  </div>
                ))}
              </GridLayout>
            </div>
          )}

        {props.getModularOpened === "modularOpened" &&
          props.getSensorType === "hzLocation" &&
          singleWindow === true && (
            <div className={`popupWrappers`}>
              <GridLayout
                key={keyHz}
                className="layout"
                cols={1}
                rowHeight={750}
                width={sideMenuWidth - 15}
                isResizable={false}
                draggableCancel=".no-drag"
              >
                {tempPopupsHz.slice(0, 1).map((hz, index) => (
                  <div key={`${hz.sensorId}`}>
                    <SideMenuReportedIncident
                      incidentId={hz.sensorId!}
                      adm4_en={hz.adm4_en}
                      bwater_level={hz.bwater_level}
                      end_time={hz.end_time}
                      hwater_level={hz.hwater_level}
                      img_url={hz.img_url}
                      imp_communication={hz.imp_communication}
                      imp_electricity={hz.imp_electricity}
                      imp_house={hz.imp_house}
                      imp_human={hz.imp_human}
                      imp_response={hz.imp_response}
                      imp_roadblock={hz.imp_roadblock}
                      imp_roaddamage={hz.imp_roaddamage}
                      imp_water={hz.imp_water}
                      impdes_communication={hz.impdes_communication}
                      impdes_electricity={hz.impdes_electricity}
                      impdes_house={hz.impdes_house}
                      impdes_human={hz.impdes_human}
                      impdes_roadblock={hz.impdes_roadblock}
                      impdes_roaddamage={hz.impdes_roaddamage}
                      impdes_water={hz.impdes_water}
                      issued_time={hz.issued_time}
                      occurance_date={hz.occurance_date}
                      observed_date={hz.observed_date}
                      tp_number={hz.tp_number}
                      w_desc={hz.w_desc}
                      w_name={hz.w_name}
                      w_type={hz.w_type}
                      setHzRender={toggleHzRender}
                      removeItem={removeItem}
                      addItem={addItem}
                      coordinatesPopup={hz.coordinates!}
                    />
                  </div>
                ))}
              </GridLayout>
            </div>
          )}
        {props.getModularOpened === "modularOpened" &&
          isSideMenuSimulationStatus && (
            <GridLayout
              key={keySim}
              className="layout"
              layout={tempLayoutSimulation}
              cols={1}
              rowHeight={660}
              width={sideMenuWidth - 15}
              isResizable={false}
              draggableCancel=".no-drag"
            >
              {tempPopupSimulation.map((popup, index) => (
                <div key={popup.id}>
                  <div className={`popupWrappers`}>
                    <SideMenuFloodSimulation
                      setWindowState={setIsSideMenuSimulationStatus}
                      terminalCommands={props.terminalCommands}
                      terminalState={props.terminalState}
                      notifications={props.notifications}
                      removeItem={removeItem}
                      handleClosePopup={props.handleClosePopup}
                      runButtonOnClick={props.runButtonOnClick}
                      addItem={addItem}
                      data={popup}
                      setIsSideMenuSimulationStatus={
                        setIsSideMenuSimulationStatus
                      }
                    />
                  </div>
                </div>
              ))}
            </GridLayout>
          )}

        {props.getModularOpened === "modularOpened" &&
          isSideMenuSimulationCycloneSimStatus && (
            <GridLayout
              key={keyCycloneSim}
              className="layout"
              layout={gridLayoutCycloneSim}
              cols={1}
              rowHeight={660}
              width={sideMenuWidth - 15}
              isResizable={false}
              draggableCancel=".no-drag"
            >
              {tempPopupsCycloneSim.map((popup, index) => (
                <div key={popup.id}>
                  <div className={`popupWrappers`}>
                    <SideMenuFloodSimulation
                      setWindowState={setIsSideMenuSimulationStatus}
                      terminalCommands={props.terminalCommands}
                      terminalState={props.terminalState}
                      notifications={props.notifications}
                      removeItem={removeItem}
                      handleClosePopup={props.handleClosePopup}
                      runButtonOnClick={props.runButtonOnClick}
                      addItem={addItem}
                      data={popup}
                      setIsSideMenuSimulationStatus={
                        setIsSideMenuSimulationStatus
                      }
                    />
                  </div>
                </div>
              ))}
            </GridLayout>
          )}

        {props.getModularOpened === "modularOpened" &&
          isSideMenuSimulationAtmosphericRiverSimStatus && (
            <GridLayout
              key={keyAtmosphericRiverSim}
              className="layout"
              layout={gridLayoutAtmosphericRiverSim}
              cols={1}
              rowHeight={660}
              width={sideMenuWidth - 15}
              isResizable={false}
              draggableCancel=".no-drag"
            >
              {tempPopupsAtmosphericRiverSim.map((popup, index) => (
                <div key={popup.id}>
                  <div className={`popupWrappers`}>
                    <SideMenuFloodSimulation
                      setWindowState={setIsSideMenuSimulationStatus}
                      terminalCommands={props.terminalCommands}
                      terminalState={props.terminalState}
                      notifications={props.notifications}
                      removeItem={removeItem}
                      handleClosePopup={props.handleClosePopup}
                      runButtonOnClick={props.runButtonOnClick}
                      addItem={addItem}
                      data={popup}
                      setIsSideMenuSimulationStatus={
                        setIsSideMenuSimulationStatus
                      }
                    />
                  </div>
                </div>
              ))}
            </GridLayout>
          )}

        {props.getModularOpened === "modularOpened" &&
          isSideMenuSimulationTornadoSimStatus && (
            <GridLayout
              key={keyTornadoSim}
              className="layout"
              layout={gridLayoutTornadoSim}
              cols={1}
              rowHeight={660}
              width={sideMenuWidth - 15}
              isResizable={false}
              draggableCancel=".no-drag"
              onLayoutChange={handleLayoutChangeTornadoSim}
            >
              {tempPopupsTornadoSim.map((popup, index) => (
                <div key={popup.id}>
                  <div className={`popupWrappers`}>
                    <SideMenuTornadoSimPopup
                      setWindowState={setIsSideMenuSimulationStatus}
                      terminalCommands={props.terminalCommands}
                      terminalState={props.terminalState}
                      notifications={props.notifications}
                      removeItem={removeItem}
                      handleClosePopup={props.handleClosePopup}
                      runButtonOnClick={props.runButtonOnClick}
                      addItem={addItem}
                      data={popup}
                      setIsSideMenuSimulationStatus={
                        setIsSideMenuSimulationTornadoSimStatus
                      }
                    />
                  </div>
                </div>
              ))}
            </GridLayout>
          )}

        {props.getModularOpened === "modularOpened" &&
          isSideMenuSimulationDroughtSimStatus && (
            <GridLayout
              key={keyDroughtSim}
              className="layout"
              layout={gridLayoutDroughtSim}
              cols={1}
              rowHeight={660}
              width={sideMenuWidth - 15}
              isResizable={false}
              draggableCancel=".no-drag"
            >
              {tempPopupsDroughtSim.map((popup, index) => (
                <div key={popup.id}>
                  <div className={`popupWrappers`}>
                    <SideMenuFloodSimulation
                      setWindowState={setIsSideMenuSimulationStatus}
                      terminalCommands={props.terminalCommands}
                      terminalState={props.terminalState}
                      notifications={props.notifications}
                      removeItem={removeItem}
                      handleClosePopup={props.handleClosePopup}
                      runButtonOnClick={props.runButtonOnClick}
                      addItem={addItem}
                      data={popup}
                      setIsSideMenuSimulationStatus={
                        setIsSideMenuSimulationStatus
                      }
                    />
                  </div>
                </div>
              ))}
            </GridLayout>
          )}

        {props.getModularOpened === "modularOpened" &&
          isSideMenuSimulationJestStreamsSimStatus && (
            <GridLayout
              key={keyJestStreamsSim}
              className="layout"
              layout={gridLayoutJestStreamsSim}
              cols={1}
              rowHeight={660}
              width={sideMenuWidth - 15}
              isResizable={false}
              draggableCancel=".no-drag"
            >
              {tempPopupsJestStreamsSim.map((popup, index) => (
                <div key={popup.id}>
                  <div className={`popupWrappers`}>
                    <SideMenuFloodSimulation
                      setWindowState={setIsSideMenuSimulationStatus}
                      terminalCommands={props.terminalCommands}
                      terminalState={props.terminalState}
                      notifications={props.notifications}
                      removeItem={removeItem}
                      handleClosePopup={props.handleClosePopup}
                      runButtonOnClick={props.runButtonOnClick}
                      addItem={addItem}
                      data={popup}
                      setIsSideMenuSimulationStatus={
                        setIsSideMenuSimulationStatus
                      }
                    />
                  </div>
                </div>
              ))}
            </GridLayout>
          )}

        {props.getModularOpened === "modularOpened" &&
          isSideMenuSimulationStormSurgeSimStatus && (
            <GridLayout
              key={keyStormSurgeSim}
              className="layout"
              layout={gridLayoutStormSurgeSim}
              cols={1}
              rowHeight={660}
              width={sideMenuWidth - 15}
              isResizable={false}
              draggableCancel=".no-drag"
            >
              {tempPopupsStormSurgeSim.map((popup, index) => (
                <div key={popup.id}>
                  <div className={`popupWrappers`}>
                    <SideMenuFloodSimulation
                      setWindowState={setIsSideMenuSimulationStatus}
                      terminalCommands={props.terminalCommands}
                      terminalState={props.terminalState}
                      notifications={props.notifications}
                      removeItem={removeItem}
                      handleClosePopup={props.handleClosePopup}
                      runButtonOnClick={props.runButtonOnClick}
                      addItem={addItem}
                      data={popup}
                      setIsSideMenuSimulationStatus={
                        setIsSideMenuSimulationStatus
                      }
                    />
                  </div>
                </div>
              ))}
            </GridLayout>
          )}

        {props.getModularOpened === "modularOpened" &&
          isSideMenuSimulationDustSurgeSimStatus && (
            <GridLayout
              key={keyDustSurgeSim}
              className="layout"
              layout={gridLayoutDustSurgeSim}
              cols={1}
              rowHeight={660}
              width={sideMenuWidth - 15}
              isResizable={false}
              draggableCancel=".no-drag"
            >
              {tempPopupsDustSurgeSim.map((popup, index) => (
                <div key={popup.id}>
                  <div className={`popupWrappers`}>
                    <SideMenuFloodSimulation
                      setWindowState={setIsSideMenuSimulationStatus}
                      terminalCommands={props.terminalCommands}
                      terminalState={props.terminalState}
                      notifications={props.notifications}
                      removeItem={removeItem}
                      handleClosePopup={props.handleClosePopup}
                      runButtonOnClick={props.runButtonOnClick}
                      addItem={addItem}
                      data={popup}
                      setIsSideMenuSimulationStatus={
                        setIsSideMenuSimulationStatus
                      }
                    />
                  </div>
                </div>
              ))}
            </GridLayout>
          )}

        {props.getModularOpened === "modularOpened" &&
          props.detailsByTypeOpen &&
          props.getSummeryType === "incidentType" && (
            <GridLayout
              key={keyDetail}
              className="layout"
              layout={sumDetail}
              cols={1}
              rowHeight={670}
              width={sideMenuWidth - 15}
              isResizable={false}
              draggableCancel=".no-drag"
            >
              {tempSumDetails.map((popup, index) => (
                <div key={popup.id}>
                  <div className={`popupWrappers`}>
                    <SumDetailByType
                      setWindowState={setIsSideMenuSimulationStatus}
                      earlyWarningsFromChild={props.earlyWarningsFromChild}
                      filterHzByType={props.filterHzByType}
                      typeWindow={props.typeWindow}
                      data={popup}
                      removeItem={removeItem}
                      addItem={addItem}
                      onClose={props.onCloseByType}
                      SumDetailAdd={SumDetailAdd}
                      onCloseDetailPopup={onCloseDetailPopup}
                    />
                  </div>
                </div>
              ))}
            </GridLayout>
          )}
        {props.getModularOpened === "modularOpened" &&
          props.isEwsServerityOpen &&
          props.getSummeryType === "severity" && (
            <GridLayout
              key={keySeverity}
              className="layout"
              layout={sumSeverity}
              cols={1}
              rowHeight={670}
              width={sideMenuWidth - 15}
              isResizable={false}
              draggableCancel=".no-drag"
            >
              {tempSumSeverity.map((popup, index) => (
                <div key={popup.id}>
                  <div className={`popupWrappers`}>
                    <SumServerity
                      setWindowState={setIsSideMenuSimulationStatus}
                      filterEws={props.filterEws}
                      ewSeverityWindow={props.ewSeverityWindow}
                      data={popup}
                      removeItem={removeItem}
                      addItem={addItem}
                      onClose={props.onCloseBySeverity}
                      SumSeverityAdd={SumSeverityAdd}
                      onCloseSeverityPopup={onCloseSeverityPopup}
                    />
                  </div>
                </div>
              ))}
            </GridLayout>
          )}
        {props.getModularOpened === "modularOpened" &&
          props.isSummaryMoreDetailsOpen &&
          props.getSummeryType === "summeryFull" && (
            <GridLayout
              key={keyInfo}
              className="layout"
              layout={tempLayoutInfo}
              cols={1}
              rowHeight={670}
              width={sideMenuWidth - 15}
              isResizable={false}
              draggableCancel=".no-drag"
            >
              {tempPopupInfo.map((popup, index) => (
                <div key={popup.id}>
                  <div className={`popupWrappers`}>
                    <SumFull
                      setWindowState={setIsSideMenuSimulationStatus}
                      earlyWarningsFull={props.earlyWarningsFull}
                      hzDatafromSummery={props.hzDatafromSummery}
                      moreDetailWindow={props.moreDetailWindow}
                      data={popup}
                      removeItem={removeItem}
                      addItem={addItem}
                      onClose={props.onClose}
                    />
                  </div>
                </div>
              ))}
            </GridLayout>
          )}
      </div>
      <a className={`watermark-link`} href="https://www.tecxal.com/">
        <span className={`watermark`}>
          &copy; 2025 Tecxal Systems Ltd. All rights reserved.
        </span>
      </a>
    </div>
  );
};

export default RightSideMenu;
